/* tslint:disable */
/* eslint-disable */
//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v13.4.2.0 (NJsonSchema v10.1.11.0 (Newtonsoft.Json v12.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------
// ReSharper disable InconsistentNaming

import {default_headers, getAuthToken} from './AuthHeaders';
import { mergeMap as _observableMergeMap, catchError as _observableCatch } from 'rxjs/operators';
import { Observable, from as _observableFrom, throwError as _observableThrow, of as _observableOf } from 'rxjs';
import { Injectable, Inject, Optional, InjectionToken } from '@angular/core';
import { HttpClient, HttpHeaders, HttpResponse, HttpResponseBase } from '@angular/common/http';

import * as moment from 'moment';

export const API_BASE_URL = new InjectionToken<string>('API_BASE_URL');

export class ClientBase {
    protected transformOptions(options: any) {

        let token = getAuthToken();

        var old_headers: HttpHeaders = <HttpHeaders>options.headers;
        var new_headers: {[key: string]: string} = {};
        old_headers.keys().forEach(k => {
            new_headers[k] = old_headers.get(k);
        });
        if(token && token != '') {
            new_headers["Authorization"] = "Bearer " + token;
        }

        Object.keys(default_headers).forEach(k => {
            new_headers[k] = default_headers[k];
        });

        options.headers = new HttpHeaders(new_headers);

        //console.log("HTTP call, options: " + JSON.stringify(options));
        return Promise.resolve(options);
    }

    protected transformResult(url: string, response: Response, processor: (response: Response) => any) {
        // TODO: Return own result or throw exception to change default processing behavior, 
        // or call processor function to run the default processing logic

        //console.log("Service call: " + url);
        return processor(response);
    }
}

export interface IAdsClient {
    getAds(): Observable<Ads>;
}

@Injectable({
    providedIn: 'root'
})
export class AdsClient extends ClientBase implements IAdsClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        super();
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "http://wicked.infosystrade.com";
    }

    getAds(): Observable<Ads> {
        let url_ = this.baseUrl + "/api/Ads";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("get", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processGetAds(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAds(<any>response_);
                } catch (e) {
                    return <Observable<Ads>><any>_observableThrow(e);
                }
            } else
                return <Observable<Ads>><any>_observableThrow(response_);
        }));
    }

    protected processGetAds(response: HttpResponseBase): Observable<Ads> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = Ads.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<Ads>(<any>null);
    }
}

export interface IAdveristmentsClient {
    markAsSeenByDemo(model: AdvertisementMarkAsSeenRequestModel): Observable<AdvertisementMarkAsSeenResponseModel>;
    getCategories(): Observable<DTOAdvertisementCategory[]>;
    getCategoriesJS(): Observable<FileResponse | null>;
    getRegions(): Observable<DTORegion[]>;
    getRegionsOnly(): Observable<DTORegion[]>;
    getChildrenSubRegions(subRegionId: number): Observable<DTOSubRegion[]>;
    repost(model: AdvertistmentRepostModel): Observable<AdvertistmentRepostResponse>;
    create(model: AdveristmentCreateModel): Observable<AdveristmentCreateResponse>;
    update(model: AdveristmentUpdateModel): Observable<AdveristmentUpdateResponse>;
    delete(model: AdveristmentDeleteModel): Observable<AdveristmentDeleteResponse>;
    getAdvertisementData(advId?: number | undefined): Observable<AdveristmentGetResponse>;
    get(model: AdveristmentGetModel): Observable<AdveristmentGetResponse>;
    getGoogleKey(): Observable<string>;
    getBlogUrl(): Observable<string>;
    createAdWriteInformation(data: AdWritterInformationRequest): Observable<AdWritterInformationResponse>;
}

@Injectable({
    providedIn: 'root'
})
export class AdveristmentsClient extends ClientBase implements IAdveristmentsClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        super();
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "http://wicked.infosystrade.com";
    }

    markAsSeenByDemo(model: AdvertisementMarkAsSeenRequestModel): Observable<AdvertisementMarkAsSeenResponseModel> {
        let url_ = this.baseUrl + "/api/Adveristments/markAsSeen";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processMarkAsSeenByDemo(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processMarkAsSeenByDemo(<any>response_);
                } catch (e) {
                    return <Observable<AdvertisementMarkAsSeenResponseModel>><any>_observableThrow(e);
                }
            } else
                return <Observable<AdvertisementMarkAsSeenResponseModel>><any>_observableThrow(response_);
        }));
    }

    protected processMarkAsSeenByDemo(response: HttpResponseBase): Observable<AdvertisementMarkAsSeenResponseModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AdvertisementMarkAsSeenResponseModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<AdvertisementMarkAsSeenResponseModel>(<any>null);
    }

    getCategories(): Observable<DTOAdvertisementCategory[]> {
        let url_ = this.baseUrl + "/api/Adveristments/GetCategories";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("get", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processGetCategories(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCategories(<any>response_);
                } catch (e) {
                    return <Observable<DTOAdvertisementCategory[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<DTOAdvertisementCategory[]>><any>_observableThrow(response_);
        }));
    }

    protected processGetCategories(response: HttpResponseBase): Observable<DTOAdvertisementCategory[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(DTOAdvertisementCategory.fromJS(item));
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<DTOAdvertisementCategory[]>(<any>null);
    }

    getCategoriesJS(): Observable<FileResponse | null> {
        let url_ = this.baseUrl + "/api/Adveristments/getcategories/js";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/octet-stream"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("get", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processGetCategoriesJS(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCategoriesJS(<any>response_);
                } catch (e) {
                    return <Observable<FileResponse | null>><any>_observableThrow(e);
                }
            } else
                return <Observable<FileResponse | null>><any>_observableThrow(response_);
        }));
    }

    protected processGetCategoriesJS(response: HttpResponseBase): Observable<FileResponse | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            const fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
            const fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            return _observableOf({ fileName: fileName, data: <any>responseBlob, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<FileResponse | null>(<any>null);
    }

    getRegions(): Observable<DTORegion[]> {
        let url_ = this.baseUrl + "/api/Adveristments/GetRegions";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("get", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processGetRegions(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetRegions(<any>response_);
                } catch (e) {
                    return <Observable<DTORegion[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<DTORegion[]>><any>_observableThrow(response_);
        }));
    }

    protected processGetRegions(response: HttpResponseBase): Observable<DTORegion[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(DTORegion.fromJS(item));
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<DTORegion[]>(<any>null);
    }

    getRegionsOnly(): Observable<DTORegion[]> {
        let url_ = this.baseUrl + "/api/Adveristments/GetRegionsOnly";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("get", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processGetRegionsOnly(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetRegionsOnly(<any>response_);
                } catch (e) {
                    return <Observable<DTORegion[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<DTORegion[]>><any>_observableThrow(response_);
        }));
    }

    protected processGetRegionsOnly(response: HttpResponseBase): Observable<DTORegion[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(DTORegion.fromJS(item));
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<DTORegion[]>(<any>null);
    }

    getChildrenSubRegions(subRegionId: number): Observable<DTOSubRegion[]> {
        let url_ = this.baseUrl + "/api/Adveristments/GetChildrenSubRegions/{subRegionId}";
        if (subRegionId === undefined || subRegionId === null)
            throw new Error("The parameter 'subRegionId' must be defined.");
        url_ = url_.replace("{subRegionId}", encodeURIComponent("" + subRegionId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("get", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processGetChildrenSubRegions(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetChildrenSubRegions(<any>response_);
                } catch (e) {
                    return <Observable<DTOSubRegion[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<DTOSubRegion[]>><any>_observableThrow(response_);
        }));
    }

    protected processGetChildrenSubRegions(response: HttpResponseBase): Observable<DTOSubRegion[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(DTOSubRegion.fromJS(item));
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<DTOSubRegion[]>(<any>null);
    }

    repost(model: AdvertistmentRepostModel): Observable<AdvertistmentRepostResponse> {
        let url_ = this.baseUrl + "/api/Adveristments/repost";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processRepost(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRepost(<any>response_);
                } catch (e) {
                    return <Observable<AdvertistmentRepostResponse>><any>_observableThrow(e);
                }
            } else
                return <Observable<AdvertistmentRepostResponse>><any>_observableThrow(response_);
        }));
    }

    protected processRepost(response: HttpResponseBase): Observable<AdvertistmentRepostResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AdvertistmentRepostResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<AdvertistmentRepostResponse>(<any>null);
    }

    create(model: AdveristmentCreateModel): Observable<AdveristmentCreateResponse> {
        let url_ = this.baseUrl + "/api/Adveristments/create";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processCreate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreate(<any>response_);
                } catch (e) {
                    return <Observable<AdveristmentCreateResponse>><any>_observableThrow(e);
                }
            } else
                return <Observable<AdveristmentCreateResponse>><any>_observableThrow(response_);
        }));
    }

    protected processCreate(response: HttpResponseBase): Observable<AdveristmentCreateResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AdveristmentCreateResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<AdveristmentCreateResponse>(<any>null);
    }

    update(model: AdveristmentUpdateModel): Observable<AdveristmentUpdateResponse> {
        let url_ = this.baseUrl + "/api/Adveristments/update";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdate(<any>response_);
                } catch (e) {
                    return <Observable<AdveristmentUpdateResponse>><any>_observableThrow(e);
                }
            } else
                return <Observable<AdveristmentUpdateResponse>><any>_observableThrow(response_);
        }));
    }

    protected processUpdate(response: HttpResponseBase): Observable<AdveristmentUpdateResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AdveristmentUpdateResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<AdveristmentUpdateResponse>(<any>null);
    }

    delete(model: AdveristmentDeleteModel): Observable<AdveristmentDeleteResponse> {
        let url_ = this.baseUrl + "/api/Adveristments/delete";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(<any>response_);
                } catch (e) {
                    return <Observable<AdveristmentDeleteResponse>><any>_observableThrow(e);
                }
            } else
                return <Observable<AdveristmentDeleteResponse>><any>_observableThrow(response_);
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<AdveristmentDeleteResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AdveristmentDeleteResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<AdveristmentDeleteResponse>(<any>null);
    }

    getAdvertisementData(advId?: number | undefined): Observable<AdveristmentGetResponse> {
        let url_ = this.baseUrl + "/api/Adveristments/GetAdvertisementData?";
        if (advId === null)
            throw new Error("The parameter 'advId' cannot be null.");
        else if (advId !== undefined)
            url_ += "advId=" + encodeURIComponent("" + advId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("get", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processGetAdvertisementData(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAdvertisementData(<any>response_);
                } catch (e) {
                    return <Observable<AdveristmentGetResponse>><any>_observableThrow(e);
                }
            } else
                return <Observable<AdveristmentGetResponse>><any>_observableThrow(response_);
        }));
    }

    protected processGetAdvertisementData(response: HttpResponseBase): Observable<AdveristmentGetResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AdveristmentGetResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<AdveristmentGetResponse>(<any>null);
    }

    get(model: AdveristmentGetModel): Observable<AdveristmentGetResponse> {
        let url_ = this.baseUrl + "/api/Adveristments/get";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(<any>response_);
                } catch (e) {
                    return <Observable<AdveristmentGetResponse>><any>_observableThrow(e);
                }
            } else
                return <Observable<AdveristmentGetResponse>><any>_observableThrow(response_);
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<AdveristmentGetResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AdveristmentGetResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<AdveristmentGetResponse>(<any>null);
    }

    getGoogleKey(): Observable<string> {
        let url_ = this.baseUrl + "/api/Adveristments/GetGoogleKey";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("get", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processGetGoogleKey(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetGoogleKey(<any>response_);
                } catch (e) {
                    return <Observable<string>><any>_observableThrow(e);
                }
            } else
                return <Observable<string>><any>_observableThrow(response_);
        }));
    }

    protected processGetGoogleKey(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<string>(<any>null);
    }

    getBlogUrl(): Observable<string> {
        let url_ = this.baseUrl + "/api/Adveristments/GetBlogUrl";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("get", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processGetBlogUrl(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetBlogUrl(<any>response_);
                } catch (e) {
                    return <Observable<string>><any>_observableThrow(e);
                }
            } else
                return <Observable<string>><any>_observableThrow(response_);
        }));
    }

    protected processGetBlogUrl(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<string>(<any>null);
    }

    createAdWriteInformation(data: AdWritterInformationRequest): Observable<AdWritterInformationResponse> {
        let url_ = this.baseUrl + "/api/Adveristments/CreateAdWriteInformation";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(data);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processCreateAdWriteInformation(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateAdWriteInformation(<any>response_);
                } catch (e) {
                    return <Observable<AdWritterInformationResponse>><any>_observableThrow(e);
                }
            } else
                return <Observable<AdWritterInformationResponse>><any>_observableThrow(response_);
        }));
    }

    protected processCreateAdWriteInformation(response: HttpResponseBase): Observable<AdWritterInformationResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AdWritterInformationResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<AdWritterInformationResponse>(<any>null);
    }
}

export interface IAuthClient {
    login(user: LoginModel): Observable<LoginResponseModel>;
}

@Injectable({
    providedIn: 'root'
})
export class AuthClient extends ClientBase implements IAuthClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        super();
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "http://wicked.infosystrade.com";
    }

    login(user: LoginModel): Observable<LoginResponseModel> {
        let url_ = this.baseUrl + "/api/auth/login";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(user);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processLogin(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processLogin(<any>response_);
                } catch (e) {
                    return <Observable<LoginResponseModel>><any>_observableThrow(e);
                }
            } else
                return <Observable<LoginResponseModel>><any>_observableThrow(response_);
        }));
    }

    protected processLogin(response: HttpResponseBase): Observable<LoginResponseModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = LoginResponseModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<LoginResponseModel>(<any>null);
    }
}

export interface ICaptchaClient {
    getCaptchaKey(): Observable<string>;
}

@Injectable({
    providedIn: 'root'
})
export class CaptchaClient extends ClientBase implements ICaptchaClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        super();
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "http://wicked.infosystrade.com";
    }

    getCaptchaKey(): Observable<string> {
        let url_ = this.baseUrl + "/api/Captcha/GetCaptchaKey";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("get", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processGetCaptchaKey(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCaptchaKey(<any>response_);
                } catch (e) {
                    return <Observable<string>><any>_observableThrow(e);
                }
            } else
                return <Observable<string>><any>_observableThrow(response_);
        }));
    }

    protected processGetCaptchaKey(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<string>(<any>null);
    }
}

export interface IConversationClient {
    deleteConversation(deleteRequestModel: ConversationDeleteRequestModel): Observable<ConversationDeleteResponseModel>;
    getConversation(conversationId?: number | undefined): Observable<GetConversationResponseModel>;
    getConversations(requestModel: UserConversationsRequestModel): Observable<UserConversationsResponseModel>;
    sendConversationMessage(requestModel: ConversationMessageSubmitRequestModel): Observable<MessageSubmitResponseModel>;
    sendStartingMessage(requestModel: StartConversationMessageSubmitRequestModel): Observable<MessageSubmitResponseModel>;
    getUnreadedMessages(): Observable<number>;
    setReadedMessages(messagesIds: number[], conversationId?: number | undefined): Observable<boolean>;
}

@Injectable({
    providedIn: 'root'
})
export class ConversationClient extends ClientBase implements IConversationClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        super();
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "http://wicked.infosystrade.com";
    }

    deleteConversation(deleteRequestModel: ConversationDeleteRequestModel): Observable<ConversationDeleteResponseModel> {
        let url_ = this.baseUrl + "/api/Conversation/delete";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(deleteRequestModel);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processDeleteConversation(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteConversation(<any>response_);
                } catch (e) {
                    return <Observable<ConversationDeleteResponseModel>><any>_observableThrow(e);
                }
            } else
                return <Observable<ConversationDeleteResponseModel>><any>_observableThrow(response_);
        }));
    }

    protected processDeleteConversation(response: HttpResponseBase): Observable<ConversationDeleteResponseModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ConversationDeleteResponseModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ConversationDeleteResponseModel>(<any>null);
    }

    getConversation(conversationId?: number | undefined): Observable<GetConversationResponseModel> {
        let url_ = this.baseUrl + "/api/Conversation/getConversation?";
        if (conversationId === null)
            throw new Error("The parameter 'conversationId' cannot be null.");
        else if (conversationId !== undefined)
            url_ += "conversationId=" + encodeURIComponent("" + conversationId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processGetConversation(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetConversation(<any>response_);
                } catch (e) {
                    return <Observable<GetConversationResponseModel>><any>_observableThrow(e);
                }
            } else
                return <Observable<GetConversationResponseModel>><any>_observableThrow(response_);
        }));
    }

    protected processGetConversation(response: HttpResponseBase): Observable<GetConversationResponseModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetConversationResponseModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetConversationResponseModel>(<any>null);
    }

    getConversations(requestModel: UserConversationsRequestModel): Observable<UserConversationsResponseModel> {
        let url_ = this.baseUrl + "/api/Conversation/get";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(requestModel);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processGetConversations(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetConversations(<any>response_);
                } catch (e) {
                    return <Observable<UserConversationsResponseModel>><any>_observableThrow(e);
                }
            } else
                return <Observable<UserConversationsResponseModel>><any>_observableThrow(response_);
        }));
    }

    protected processGetConversations(response: HttpResponseBase): Observable<UserConversationsResponseModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UserConversationsResponseModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<UserConversationsResponseModel>(<any>null);
    }

    sendConversationMessage(requestModel: ConversationMessageSubmitRequestModel): Observable<MessageSubmitResponseModel> {
        let url_ = this.baseUrl + "/api/Conversation/sendConversationMessage";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(requestModel);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processSendConversationMessage(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSendConversationMessage(<any>response_);
                } catch (e) {
                    return <Observable<MessageSubmitResponseModel>><any>_observableThrow(e);
                }
            } else
                return <Observable<MessageSubmitResponseModel>><any>_observableThrow(response_);
        }));
    }

    protected processSendConversationMessage(response: HttpResponseBase): Observable<MessageSubmitResponseModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = MessageSubmitResponseModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<MessageSubmitResponseModel>(<any>null);
    }

    sendStartingMessage(requestModel: StartConversationMessageSubmitRequestModel): Observable<MessageSubmitResponseModel> {
        let url_ = this.baseUrl + "/api/Conversation/sendStartingMessage";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(requestModel);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processSendStartingMessage(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSendStartingMessage(<any>response_);
                } catch (e) {
                    return <Observable<MessageSubmitResponseModel>><any>_observableThrow(e);
                }
            } else
                return <Observable<MessageSubmitResponseModel>><any>_observableThrow(response_);
        }));
    }

    protected processSendStartingMessage(response: HttpResponseBase): Observable<MessageSubmitResponseModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = MessageSubmitResponseModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<MessageSubmitResponseModel>(<any>null);
    }

    getUnreadedMessages(): Observable<number> {
        let url_ = this.baseUrl + "/api/Conversation/GetUnreadedMessages";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("get", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processGetUnreadedMessages(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetUnreadedMessages(<any>response_);
                } catch (e) {
                    return <Observable<number>><any>_observableThrow(e);
                }
            } else
                return <Observable<number>><any>_observableThrow(response_);
        }));
    }

    protected processGetUnreadedMessages(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<number>(<any>null);
    }

    setReadedMessages(messagesIds: number[], conversationId?: number | undefined): Observable<boolean> {
        let url_ = this.baseUrl + "/api/Conversation/SetReadedMessages?";
        if (conversationId === null)
            throw new Error("The parameter 'conversationId' cannot be null.");
        else if (conversationId !== undefined)
            url_ += "conversationId=" + encodeURIComponent("" + conversationId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(messagesIds);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processSetReadedMessages(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSetReadedMessages(<any>response_);
                } catch (e) {
                    return <Observable<boolean>><any>_observableThrow(e);
                }
            } else
                return <Observable<boolean>><any>_observableThrow(response_);
        }));
    }

    protected processSetReadedMessages(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<boolean>(<any>null);
    }
}

export interface IEmojiClient {
    getEmojis(): Observable<EmojiResponseModel>;
}

@Injectable({
    providedIn: 'root'
})
export class EmojiClient extends ClientBase implements IEmojiClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        super();
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "http://wicked.infosystrade.com";
    }

    getEmojis(): Observable<EmojiResponseModel> {
        let url_ = this.baseUrl + "/api/Emoji/GetEmojis";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("get", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processGetEmojis(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetEmojis(<any>response_);
                } catch (e) {
                    return <Observable<EmojiResponseModel>><any>_observableThrow(e);
                }
            } else
                return <Observable<EmojiResponseModel>><any>_observableThrow(response_);
        }));
    }

    protected processGetEmojis(response: HttpResponseBase): Observable<EmojiResponseModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = EmojiResponseModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<EmojiResponseModel>(<any>null);
    }
}

export interface IFileClient {
    read(pathInfo: string | null, maxWidth: number, maxheight: number): Observable<FileResponse | null>;
    read2(pathInfo: string | null): Observable<FileResponse | null>;
    temporaryUpload(): Observable<FileResponse | null>;
}

@Injectable({
    providedIn: 'root'
})
export class FileClient extends ClientBase implements IFileClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        super();
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "http://wicked.infosystrade.com";
    }

    read(pathInfo: string | null, maxWidth: number, maxheight: number): Observable<FileResponse | null> {
        let url_ = this.baseUrl + "/FileGet/{pathInfo}/{maxWidth}x{maxheight}";
        if (pathInfo === undefined || pathInfo === null)
            throw new Error("The parameter 'pathInfo' must be defined.");
        url_ = url_.replace("{pathInfo}", encodeURIComponent("" + pathInfo));
        if (maxWidth === undefined || maxWidth === null)
            throw new Error("The parameter 'maxWidth' must be defined.");
        url_ = url_.replace("{maxWidth}", encodeURIComponent("" + maxWidth));
        if (maxheight === undefined || maxheight === null)
            throw new Error("The parameter 'maxheight' must be defined.");
        url_ = url_.replace("{maxheight}", encodeURIComponent("" + maxheight));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/octet-stream"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("get", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processRead(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRead(<any>response_);
                } catch (e) {
                    return <Observable<FileResponse | null>><any>_observableThrow(e);
                }
            } else
                return <Observable<FileResponse | null>><any>_observableThrow(response_);
        }));
    }

    protected processRead(response: HttpResponseBase): Observable<FileResponse | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            const fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
            const fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            return _observableOf({ fileName: fileName, data: <any>responseBlob, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<FileResponse | null>(<any>null);
    }

    read2(pathInfo: string | null): Observable<FileResponse | null> {
        let url_ = this.baseUrl + "/FileGet/{pathInfo}";
        if (pathInfo === undefined || pathInfo === null)
            throw new Error("The parameter 'pathInfo' must be defined.");
        url_ = url_.replace("{pathInfo}", encodeURIComponent("" + pathInfo));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/octet-stream"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("get", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processRead2(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRead2(<any>response_);
                } catch (e) {
                    return <Observable<FileResponse | null>><any>_observableThrow(e);
                }
            } else
                return <Observable<FileResponse | null>><any>_observableThrow(response_);
        }));
    }

    protected processRead2(response: HttpResponseBase): Observable<FileResponse | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            const fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
            const fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            return _observableOf({ fileName: fileName, data: <any>responseBlob, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<FileResponse | null>(<any>null);
    }

    temporaryUpload(): Observable<FileResponse | null> {
        let url_ = this.baseUrl + "/File/TemporaryUpload";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/octet-stream"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processTemporaryUpload(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processTemporaryUpload(<any>response_);
                } catch (e) {
                    return <Observable<FileResponse | null>><any>_observableThrow(e);
                }
            } else
                return <Observable<FileResponse | null>><any>_observableThrow(response_);
        }));
    }

    protected processTemporaryUpload(response: HttpResponseBase): Observable<FileResponse | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            const fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
            const fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            return _observableOf({ fileName: fileName, data: <any>responseBlob, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<FileResponse | null>(<any>null);
    }
}

export interface IGeolocationClient {
    subRegionByLatLng(latitude?: number | undefined, longitude?: number | undefined): Observable<SubRegion>;
    asd(): Observable<SubRegion[]>;
    cityMostPopulation(top?: number | undefined): Observable<SubRegion[]>;
    cityMostPopulationJS(top?: number | undefined): Observable<FileResponse | null>;
    getSubregionByZip(zip?: string | null | undefined): Observable<SubRegion>;
    getSubregionByIP(ip?: string | null | undefined): Observable<SubRegion>;
    clientIp(): Observable<string[]>;
    getNearestCity(ip?: string | null | undefined): Observable<string>;
    allSubregions(): Observable<SubRegion[]>;
    allRegions(): Observable<Region[]>;
    getSubregion(subregionId?: number | undefined): Observable<SubRegion>;
    getRegion(regionId?: number | undefined): Observable<Region>;
}

@Injectable({
    providedIn: 'root'
})
export class GeolocationClient extends ClientBase implements IGeolocationClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        super();
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "http://wicked.infosystrade.com";
    }

    subRegionByLatLng(latitude?: number | undefined, longitude?: number | undefined): Observable<SubRegion> {
        let url_ = this.baseUrl + "/api/Geolocation/ClosestSubRegionByLatLng?";
        if (latitude === null)
            throw new Error("The parameter 'latitude' cannot be null.");
        else if (latitude !== undefined)
            url_ += "latitude=" + encodeURIComponent("" + latitude) + "&";
        if (longitude === null)
            throw new Error("The parameter 'longitude' cannot be null.");
        else if (longitude !== undefined)
            url_ += "longitude=" + encodeURIComponent("" + longitude) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processSubRegionByLatLng(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSubRegionByLatLng(<any>response_);
                } catch (e) {
                    return <Observable<SubRegion>><any>_observableThrow(e);
                }
            } else
                return <Observable<SubRegion>><any>_observableThrow(response_);
        }));
    }

    protected processSubRegionByLatLng(response: HttpResponseBase): Observable<SubRegion> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SubRegion.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<SubRegion>(<any>null);
    }

    asd(): Observable<SubRegion[]> {
        let url_ = this.baseUrl + "/api/Geolocation/Test";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("get", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processAsd(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAsd(<any>response_);
                } catch (e) {
                    return <Observable<SubRegion[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<SubRegion[]>><any>_observableThrow(response_);
        }));
    }

    protected processAsd(response: HttpResponseBase): Observable<SubRegion[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(SubRegion.fromJS(item));
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<SubRegion[]>(<any>null);
    }

    cityMostPopulation(top?: number | undefined): Observable<SubRegion[]> {
        let url_ = this.baseUrl + "/citybypopulation?";
        if (top === null)
            throw new Error("The parameter 'top' cannot be null.");
        else if (top !== undefined)
            url_ += "top=" + encodeURIComponent("" + top) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("get", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processCityMostPopulation(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCityMostPopulation(<any>response_);
                } catch (e) {
                    return <Observable<SubRegion[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<SubRegion[]>><any>_observableThrow(response_);
        }));
    }

    protected processCityMostPopulation(response: HttpResponseBase): Observable<SubRegion[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(SubRegion.fromJS(item));
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<SubRegion[]>(<any>null);
    }

    cityMostPopulationJS(top?: number | undefined): Observable<FileResponse | null> {
        let url_ = this.baseUrl + "/citybypopulation/js?";
        if (top === null)
            throw new Error("The parameter 'top' cannot be null.");
        else if (top !== undefined)
            url_ += "top=" + encodeURIComponent("" + top) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/octet-stream"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("get", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processCityMostPopulationJS(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCityMostPopulationJS(<any>response_);
                } catch (e) {
                    return <Observable<FileResponse | null>><any>_observableThrow(e);
                }
            } else
                return <Observable<FileResponse | null>><any>_observableThrow(response_);
        }));
    }

    protected processCityMostPopulationJS(response: HttpResponseBase): Observable<FileResponse | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            const fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
            const fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            return _observableOf({ fileName: fileName, data: <any>responseBlob, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<FileResponse | null>(<any>null);
    }

    getSubregionByZip(zip?: string | null | undefined): Observable<SubRegion> {
        let url_ = this.baseUrl + "/SubregionByZip?";
        if (zip !== undefined)
            url_ += "zip=" + encodeURIComponent("" + zip) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("get", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processGetSubregionByZip(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetSubregionByZip(<any>response_);
                } catch (e) {
                    return <Observable<SubRegion>><any>_observableThrow(e);
                }
            } else
                return <Observable<SubRegion>><any>_observableThrow(response_);
        }));
    }

    protected processGetSubregionByZip(response: HttpResponseBase): Observable<SubRegion> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SubRegion.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<SubRegion>(<any>null);
    }

    getSubregionByIP(ip?: string | null | undefined): Observable<SubRegion> {
        let url_ = this.baseUrl + "/GetSubregionByIP?";
        if (ip !== undefined)
            url_ += "ip=" + encodeURIComponent("" + ip) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("get", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processGetSubregionByIP(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetSubregionByIP(<any>response_);
                } catch (e) {
                    return <Observable<SubRegion>><any>_observableThrow(e);
                }
            } else
                return <Observable<SubRegion>><any>_observableThrow(response_);
        }));
    }

    protected processGetSubregionByIP(response: HttpResponseBase): Observable<SubRegion> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SubRegion.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<SubRegion>(<any>null);
    }

    clientIp(): Observable<string[]> {
        let url_ = this.baseUrl + "/api/Geolocation/clientIP";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("get", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processClientIp(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processClientIp(<any>response_);
                } catch (e) {
                    return <Observable<string[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<string[]>><any>_observableThrow(response_);
        }));
    }

    protected processClientIp(response: HttpResponseBase): Observable<string[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(item);
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<string[]>(<any>null);
    }

    getNearestCity(ip?: string | null | undefined): Observable<string> {
        let url_ = this.baseUrl + "/GetNearestCity?";
        if (ip !== undefined)
            url_ += "ip=" + encodeURIComponent("" + ip) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("get", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processGetNearestCity(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetNearestCity(<any>response_);
                } catch (e) {
                    return <Observable<string>><any>_observableThrow(e);
                }
            } else
                return <Observable<string>><any>_observableThrow(response_);
        }));
    }

    protected processGetNearestCity(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<string>(<any>null);
    }

    allSubregions(): Observable<SubRegion[]> {
        let url_ = this.baseUrl + "/api/Geolocation/AllSubregions";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("get", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processAllSubregions(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAllSubregions(<any>response_);
                } catch (e) {
                    return <Observable<SubRegion[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<SubRegion[]>><any>_observableThrow(response_);
        }));
    }

    protected processAllSubregions(response: HttpResponseBase): Observable<SubRegion[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(SubRegion.fromJS(item));
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<SubRegion[]>(<any>null);
    }

    allRegions(): Observable<Region[]> {
        let url_ = this.baseUrl + "/api/Geolocation/AllRegions";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("get", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processAllRegions(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAllRegions(<any>response_);
                } catch (e) {
                    return <Observable<Region[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<Region[]>><any>_observableThrow(response_);
        }));
    }

    protected processAllRegions(response: HttpResponseBase): Observable<Region[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(Region.fromJS(item));
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<Region[]>(<any>null);
    }

    getSubregion(subregionId?: number | undefined): Observable<SubRegion> {
        let url_ = this.baseUrl + "/api/Geolocation/GetSubregion?";
        if (subregionId === null)
            throw new Error("The parameter 'subregionId' cannot be null.");
        else if (subregionId !== undefined)
            url_ += "subregionId=" + encodeURIComponent("" + subregionId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("get", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processGetSubregion(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetSubregion(<any>response_);
                } catch (e) {
                    return <Observable<SubRegion>><any>_observableThrow(e);
                }
            } else
                return <Observable<SubRegion>><any>_observableThrow(response_);
        }));
    }

    protected processGetSubregion(response: HttpResponseBase): Observable<SubRegion> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SubRegion.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<SubRegion>(<any>null);
    }

    getRegion(regionId?: number | undefined): Observable<Region> {
        let url_ = this.baseUrl + "/api/Geolocation/GetRegion?";
        if (regionId === null)
            throw new Error("The parameter 'regionId' cannot be null.");
        else if (regionId !== undefined)
            url_ += "regionId=" + encodeURIComponent("" + regionId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("get", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processGetRegion(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetRegion(<any>response_);
                } catch (e) {
                    return <Observable<Region>><any>_observableThrow(e);
                }
            } else
                return <Observable<Region>><any>_observableThrow(response_);
        }));
    }

    protected processGetRegion(response: HttpResponseBase): Observable<Region> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = Region.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<Region>(<any>null);
    }
}

export interface IImportDataClient {
    usStates(): Observable<boolean>;
    test(): Observable<SubRegion[]>;
    importPopularity(): Observable<boolean>;
}

@Injectable({
    providedIn: 'root'
})
export class ImportDataClient extends ClientBase implements IImportDataClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        super();
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "http://wicked.infosystrade.com";
    }

    usStates(): Observable<boolean> {
        let url_ = this.baseUrl + "/api/ImportData/usstates";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("get", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processUsStates(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUsStates(<any>response_);
                } catch (e) {
                    return <Observable<boolean>><any>_observableThrow(e);
                }
            } else
                return <Observable<boolean>><any>_observableThrow(response_);
        }));
    }

    protected processUsStates(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<boolean>(<any>null);
    }

    test(): Observable<SubRegion[]> {
        let url_ = this.baseUrl + "/api/ImportData/test";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("get", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processTest(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processTest(<any>response_);
                } catch (e) {
                    return <Observable<SubRegion[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<SubRegion[]>><any>_observableThrow(response_);
        }));
    }

    protected processTest(response: HttpResponseBase): Observable<SubRegion[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(SubRegion.fromJS(item));
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<SubRegion[]>(<any>null);
    }

    importPopularity(): Observable<boolean> {
        let url_ = this.baseUrl + "/api/ImportData/popularity";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("get", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processImportPopularity(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processImportPopularity(<any>response_);
                } catch (e) {
                    return <Observable<boolean>><any>_observableThrow(e);
                }
            } else
                return <Observable<boolean>><any>_observableThrow(response_);
        }));
    }

    protected processImportPopularity(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<boolean>(<any>null);
    }
}

export interface IPhoneValidationClient {
    sendPhoneValidationSms(model: VerifyPhoneModel): Observable<VerifyPhoneResponseModel>;
}

@Injectable({
    providedIn: 'root'
})
export class PhoneValidationClient extends ClientBase implements IPhoneValidationClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        super();
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "http://wicked.infosystrade.com";
    }

    sendPhoneValidationSms(model: VerifyPhoneModel): Observable<VerifyPhoneResponseModel> {
        let url_ = this.baseUrl + "/send";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processSendPhoneValidationSms(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSendPhoneValidationSms(<any>response_);
                } catch (e) {
                    return <Observable<VerifyPhoneResponseModel>><any>_observableThrow(e);
                }
            } else
                return <Observable<VerifyPhoneResponseModel>><any>_observableThrow(response_);
        }));
    }

    protected processSendPhoneValidationSms(response: HttpResponseBase): Observable<VerifyPhoneResponseModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = VerifyPhoneResponseModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<VerifyPhoneResponseModel>(<any>null);
    }
}

export interface ISampleDataClient {
    zipTest(zip: ZipRequest): Observable<string>;
    weatherForecasts(): Observable<WeatherForecast[]>;
}

@Injectable({
    providedIn: 'root'
})
export class SampleDataClient extends ClientBase implements ISampleDataClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        super();
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "http://wicked.infosystrade.com";
    }

    zipTest(zip: ZipRequest): Observable<string> {
        let url_ = this.baseUrl + "/api/SampleData/ZipTest";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(zip);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processZipTest(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processZipTest(<any>response_);
                } catch (e) {
                    return <Observable<string>><any>_observableThrow(e);
                }
            } else
                return <Observable<string>><any>_observableThrow(response_);
        }));
    }

    protected processZipTest(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<string>(<any>null);
    }

    weatherForecasts(): Observable<WeatherForecast[]> {
        let url_ = this.baseUrl + "/api/SampleData/WeatherForecasts";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("get", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processWeatherForecasts(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processWeatherForecasts(<any>response_);
                } catch (e) {
                    return <Observable<WeatherForecast[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<WeatherForecast[]>><any>_observableThrow(response_);
        }));
    }

    protected processWeatherForecasts(response: HttpResponseBase): Observable<WeatherForecast[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(WeatherForecast.fromJS(item));
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<WeatherForecast[]>(<any>null);
    }
}

export interface ISubscribtionClient {
    create(data: Subscribe): Observable<CreateServiceResponse>;
    subscribtionData(): Observable<SubscribtionData[]>;
    cancelSubscribtion(subscribtionId?: string | null | undefined): Observable<boolean>;
    hasUserSubscribtion(): Observable<boolean>;
    createPremiumAdToken(data: AddPremiumAdToken): Observable<AddPremiumAdTokenResponse>;
    getUserPremiumAdTokens(): Observable<number>;
    createWriteAdToken(data: AddWriteAdToken): Observable<AddWriteAdTokenResponse>;
    getWriteAdToken(): Observable<number>;
}

@Injectable({
    providedIn: 'root'
})
export class SubscribtionClient extends ClientBase implements ISubscribtionClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        super();
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "http://wicked.infosystrade.com";
    }

    create(data: Subscribe): Observable<CreateServiceResponse> {
        let url_ = this.baseUrl + "/api/Subscribtion";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(data);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processCreate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreate(<any>response_);
                } catch (e) {
                    return <Observable<CreateServiceResponse>><any>_observableThrow(e);
                }
            } else
                return <Observable<CreateServiceResponse>><any>_observableThrow(response_);
        }));
    }

    protected processCreate(response: HttpResponseBase): Observable<CreateServiceResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CreateServiceResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<CreateServiceResponse>(<any>null);
    }

    subscribtionData(): Observable<SubscribtionData[]> {
        let url_ = this.baseUrl + "/api/Subscribtion";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("get", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processSubscribtionData(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSubscribtionData(<any>response_);
                } catch (e) {
                    return <Observable<SubscribtionData[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<SubscribtionData[]>><any>_observableThrow(response_);
        }));
    }

    protected processSubscribtionData(response: HttpResponseBase): Observable<SubscribtionData[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(SubscribtionData.fromJS(item));
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<SubscribtionData[]>(<any>null);
    }

    cancelSubscribtion(subscribtionId?: string | null | undefined): Observable<boolean> {
        let url_ = this.baseUrl + "/api/Subscribtion/CancelSubscribtion?";
        if (subscribtionId !== undefined)
            url_ += "subscribtionId=" + encodeURIComponent("" + subscribtionId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processCancelSubscribtion(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCancelSubscribtion(<any>response_);
                } catch (e) {
                    return <Observable<boolean>><any>_observableThrow(e);
                }
            } else
                return <Observable<boolean>><any>_observableThrow(response_);
        }));
    }

    protected processCancelSubscribtion(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<boolean>(<any>null);
    }

    hasUserSubscribtion(): Observable<boolean> {
        let url_ = this.baseUrl + "/api/Subscribtion/HasUserSubscribtion";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("get", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processHasUserSubscribtion(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processHasUserSubscribtion(<any>response_);
                } catch (e) {
                    return <Observable<boolean>><any>_observableThrow(e);
                }
            } else
                return <Observable<boolean>><any>_observableThrow(response_);
        }));
    }

    protected processHasUserSubscribtion(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<boolean>(<any>null);
    }

    createPremiumAdToken(data: AddPremiumAdToken): Observable<AddPremiumAdTokenResponse> {
        let url_ = this.baseUrl + "/api/Subscribtion/CreatePremiumAdToken";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(data);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processCreatePremiumAdToken(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreatePremiumAdToken(<any>response_);
                } catch (e) {
                    return <Observable<AddPremiumAdTokenResponse>><any>_observableThrow(e);
                }
            } else
                return <Observable<AddPremiumAdTokenResponse>><any>_observableThrow(response_);
        }));
    }

    protected processCreatePremiumAdToken(response: HttpResponseBase): Observable<AddPremiumAdTokenResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AddPremiumAdTokenResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<AddPremiumAdTokenResponse>(<any>null);
    }

    getUserPremiumAdTokens(): Observable<number> {
        let url_ = this.baseUrl + "/api/Subscribtion/GetUserPremiumAdTokens";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("get", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processGetUserPremiumAdTokens(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetUserPremiumAdTokens(<any>response_);
                } catch (e) {
                    return <Observable<number>><any>_observableThrow(e);
                }
            } else
                return <Observable<number>><any>_observableThrow(response_);
        }));
    }

    protected processGetUserPremiumAdTokens(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<number>(<any>null);
    }

    createWriteAdToken(data: AddWriteAdToken): Observable<AddWriteAdTokenResponse> {
        let url_ = this.baseUrl + "/api/Subscribtion/CreateWriteAdToken";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(data);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processCreateWriteAdToken(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateWriteAdToken(<any>response_);
                } catch (e) {
                    return <Observable<AddWriteAdTokenResponse>><any>_observableThrow(e);
                }
            } else
                return <Observable<AddWriteAdTokenResponse>><any>_observableThrow(response_);
        }));
    }

    protected processCreateWriteAdToken(response: HttpResponseBase): Observable<AddWriteAdTokenResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AddWriteAdTokenResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<AddWriteAdTokenResponse>(<any>null);
    }

    getWriteAdToken(): Observable<number> {
        let url_ = this.baseUrl + "/api/Subscribtion/GetWriteAdToken";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("get", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processGetWriteAdToken(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetWriteAdToken(<any>response_);
                } catch (e) {
                    return <Observable<number>><any>_observableThrow(e);
                }
            } else
                return <Observable<number>><any>_observableThrow(response_);
        }));
    }

    protected processGetWriteAdToken(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<number>(<any>null);
    }
}

export interface ITestClient {
    getDemo(model: DemoAdvertisementGetTest): Observable<TupleOfIntegerAndDateTime[]>;
}

@Injectable({
    providedIn: 'root'
})
export class TestClient extends ClientBase implements ITestClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        super();
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "http://wicked.infosystrade.com";
    }

    getDemo(model: DemoAdvertisementGetTest): Observable<TupleOfIntegerAndDateTime[]> {
        let url_ = this.baseUrl + "/api/Test/GetDemo";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processGetDemo(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetDemo(<any>response_);
                } catch (e) {
                    return <Observable<TupleOfIntegerAndDateTime[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<TupleOfIntegerAndDateTime[]>><any>_observableThrow(response_);
        }));
    }

    protected processGetDemo(response: HttpResponseBase): Observable<TupleOfIntegerAndDateTime[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(TupleOfIntegerAndDateTime.fromJS(item));
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<TupleOfIntegerAndDateTime[]>(<any>null);
    }
}

export interface IUserClient {
    register(model: RegistrationModel): Observable<RegistrationResponseModel>;
    resetPassword(model: ResetPasswordModel): Observable<ResetPasswordResponseModel>;
    getEmailFromCode(model: string): Observable<GetEmailFromCodeResponseModel>;
    newPassword(model: NewPasswordModel): Observable<ResetPasswordResponseModel>;
    validatePhone(model: ValidatePhoneModel): Observable<ValidateResponseModel>;
    validateEmail(model: ValidateModel): Observable<ValidateResponseModel>;
}

@Injectable({
    providedIn: 'root'
})
export class UserClient extends ClientBase implements IUserClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        super();
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "http://wicked.infosystrade.com";
    }

    register(model: RegistrationModel): Observable<RegistrationResponseModel> {
        let url_ = this.baseUrl + "/api/User/register";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processRegister(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRegister(<any>response_);
                } catch (e) {
                    return <Observable<RegistrationResponseModel>><any>_observableThrow(e);
                }
            } else
                return <Observable<RegistrationResponseModel>><any>_observableThrow(response_);
        }));
    }

    protected processRegister(response: HttpResponseBase): Observable<RegistrationResponseModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = RegistrationResponseModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<RegistrationResponseModel>(<any>null);
    }

    resetPassword(model: ResetPasswordModel): Observable<ResetPasswordResponseModel> {
        let url_ = this.baseUrl + "/api/User/passwordreset";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processResetPassword(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processResetPassword(<any>response_);
                } catch (e) {
                    return <Observable<ResetPasswordResponseModel>><any>_observableThrow(e);
                }
            } else
                return <Observable<ResetPasswordResponseModel>><any>_observableThrow(response_);
        }));
    }

    protected processResetPassword(response: HttpResponseBase): Observable<ResetPasswordResponseModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResetPasswordResponseModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ResetPasswordResponseModel>(<any>null);
    }

    getEmailFromCode(model: string): Observable<GetEmailFromCodeResponseModel> {
        let url_ = this.baseUrl + "/api/User/getemailfromcode";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processGetEmailFromCode(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetEmailFromCode(<any>response_);
                } catch (e) {
                    return <Observable<GetEmailFromCodeResponseModel>><any>_observableThrow(e);
                }
            } else
                return <Observable<GetEmailFromCodeResponseModel>><any>_observableThrow(response_);
        }));
    }

    protected processGetEmailFromCode(response: HttpResponseBase): Observable<GetEmailFromCodeResponseModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetEmailFromCodeResponseModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetEmailFromCodeResponseModel>(<any>null);
    }

    newPassword(model: NewPasswordModel): Observable<ResetPasswordResponseModel> {
        let url_ = this.baseUrl + "/api/User/newpassword";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processNewPassword(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processNewPassword(<any>response_);
                } catch (e) {
                    return <Observable<ResetPasswordResponseModel>><any>_observableThrow(e);
                }
            } else
                return <Observable<ResetPasswordResponseModel>><any>_observableThrow(response_);
        }));
    }

    protected processNewPassword(response: HttpResponseBase): Observable<ResetPasswordResponseModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResetPasswordResponseModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ResetPasswordResponseModel>(<any>null);
    }

    validatePhone(model: ValidatePhoneModel): Observable<ValidateResponseModel> {
        let url_ = this.baseUrl + "/api/User/phoneValidate";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processValidatePhone(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processValidatePhone(<any>response_);
                } catch (e) {
                    return <Observable<ValidateResponseModel>><any>_observableThrow(e);
                }
            } else
                return <Observable<ValidateResponseModel>><any>_observableThrow(response_);
        }));
    }

    protected processValidatePhone(response: HttpResponseBase): Observable<ValidateResponseModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ValidateResponseModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ValidateResponseModel>(<any>null);
    }

    validateEmail(model: ValidateModel): Observable<ValidateResponseModel> {
        let url_ = this.baseUrl + "/api/User/emailValidate";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processValidateEmail(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processValidateEmail(<any>response_);
                } catch (e) {
                    return <Observable<ValidateResponseModel>><any>_observableThrow(e);
                }
            } else
                return <Observable<ValidateResponseModel>><any>_observableThrow(response_);
        }));
    }

    protected processValidateEmail(response: HttpResponseBase): Observable<ValidateResponseModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ValidateResponseModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ValidateResponseModel>(<any>null);
    }
}

export interface IVersionClient {
    versionHash(t?: string | null | undefined): Observable<string>;
}

@Injectable({
    providedIn: 'root'
})
export class VersionClient extends ClientBase implements IVersionClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        super();
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "http://wicked.infosystrade.com";
    }

    versionHash(t?: string | null | undefined): Observable<string> {
        let url_ = this.baseUrl + "/api/Version?";
        if (t !== undefined)
            url_ += "t=" + encodeURIComponent("" + t) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("get", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processVersionHash(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processVersionHash(<any>response_);
                } catch (e) {
                    return <Observable<string>><any>_observableThrow(e);
                }
            } else
                return <Observable<string>><any>_observableThrow(response_);
        }));
    }

    protected processVersionHash(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<string>(<any>null);
    }
}

export class Ads implements IAds {
    leftAdId?: string | null;
    rightAdId?: string | null;
    mobileAdId?: string | null;

    constructor(data?: IAds) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.leftAdId = _data["leftAdId"] !== undefined ? _data["leftAdId"] : <any>null;
            this.rightAdId = _data["rightAdId"] !== undefined ? _data["rightAdId"] : <any>null;
            this.mobileAdId = _data["mobileAdId"] !== undefined ? _data["mobileAdId"] : <any>null;
        }
    }

    static fromJS(data: any): Ads {
        data = typeof data === 'object' ? data : {};
        let result = new Ads();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["leftAdId"] = this.leftAdId !== undefined ? this.leftAdId : <any>null;
        data["rightAdId"] = this.rightAdId !== undefined ? this.rightAdId : <any>null;
        data["mobileAdId"] = this.mobileAdId !== undefined ? this.mobileAdId : <any>null;
        return data; 
    }

    clone(): Ads {
        const json = this.toJSON();
        let result = new Ads();
        result.init(json);
        return result;
    }
}

export interface IAds {
    leftAdId?: string | null;
    rightAdId?: string | null;
    mobileAdId?: string | null;
}

export class ResponseBaseModel implements IResponseBaseModel {
    error?: string | null;
    redirectUrl?: string | null;

    constructor(data?: IResponseBaseModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.error = _data["error"] !== undefined ? _data["error"] : <any>null;
            this.redirectUrl = _data["redirectUrl"] !== undefined ? _data["redirectUrl"] : <any>null;
        }
    }

    static fromJS(data: any): ResponseBaseModel {
        data = typeof data === 'object' ? data : {};
        let result = new ResponseBaseModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["error"] = this.error !== undefined ? this.error : <any>null;
        data["redirectUrl"] = this.redirectUrl !== undefined ? this.redirectUrl : <any>null;
        return data; 
    }

    clone(): ResponseBaseModel {
        const json = this.toJSON();
        let result = new ResponseBaseModel();
        result.init(json);
        return result;
    }
}

export interface IResponseBaseModel {
    error?: string | null;
    redirectUrl?: string | null;
}

export class AdvertisementMarkAsSeenResponseModel extends ResponseBaseModel implements IAdvertisementMarkAsSeenResponseModel {

    constructor(data?: IAdvertisementMarkAsSeenResponseModel) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
    }

    static fromJS(data: any): AdvertisementMarkAsSeenResponseModel {
        data = typeof data === 'object' ? data : {};
        let result = new AdvertisementMarkAsSeenResponseModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data; 
    }

    clone(): AdvertisementMarkAsSeenResponseModel {
        const json = this.toJSON();
        let result = new AdvertisementMarkAsSeenResponseModel();
        result.init(json);
        return result;
    }
}

export interface IAdvertisementMarkAsSeenResponseModel extends IResponseBaseModel {
}

export class AdvertisementMarkAsSeenRequestModel implements IAdvertisementMarkAsSeenRequestModel {
    advertisementId!: number;
    isAdmin!: boolean;

    constructor(data?: IAdvertisementMarkAsSeenRequestModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.advertisementId = _data["advertisementId"] !== undefined ? _data["advertisementId"] : <any>null;
            this.isAdmin = _data["isAdmin"] !== undefined ? _data["isAdmin"] : <any>null;
        }
    }

    static fromJS(data: any): AdvertisementMarkAsSeenRequestModel {
        data = typeof data === 'object' ? data : {};
        let result = new AdvertisementMarkAsSeenRequestModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["advertisementId"] = this.advertisementId !== undefined ? this.advertisementId : <any>null;
        data["isAdmin"] = this.isAdmin !== undefined ? this.isAdmin : <any>null;
        return data; 
    }

    clone(): AdvertisementMarkAsSeenRequestModel {
        const json = this.toJSON();
        let result = new AdvertisementMarkAsSeenRequestModel();
        result.init(json);
        return result;
    }
}

export interface IAdvertisementMarkAsSeenRequestModel {
    advertisementId: number;
    isAdmin: boolean;
}

export class DTOBaseModel implements IDTOBaseModel {

    constructor(data?: IDTOBaseModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
    }

    static fromJS(data: any): DTOBaseModel {
        data = typeof data === 'object' ? data : {};
        let result = new DTOBaseModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        return data; 
    }

    clone(): DTOBaseModel {
        const json = this.toJSON();
        let result = new DTOBaseModel();
        result.init(json);
        return result;
    }
}

export interface IDTOBaseModel {
}

export class DTOAdvertisementCategory extends DTOBaseModel implements IDTOAdvertisementCategory {
    advertisementCategoryId!: number;
    name?: string | null;
    code?: string | null;
    orderIndex!: number;
    casualDating!: boolean;

    constructor(data?: IDTOAdvertisementCategory) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.advertisementCategoryId = _data["advertisementCategoryId"] !== undefined ? _data["advertisementCategoryId"] : <any>null;
            this.name = _data["name"] !== undefined ? _data["name"] : <any>null;
            this.code = _data["code"] !== undefined ? _data["code"] : <any>null;
            this.orderIndex = _data["orderIndex"] !== undefined ? _data["orderIndex"] : <any>null;
            this.casualDating = _data["casualDating"] !== undefined ? _data["casualDating"] : <any>null;
        }
    }

    static fromJS(data: any): DTOAdvertisementCategory {
        data = typeof data === 'object' ? data : {};
        let result = new DTOAdvertisementCategory();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["advertisementCategoryId"] = this.advertisementCategoryId !== undefined ? this.advertisementCategoryId : <any>null;
        data["name"] = this.name !== undefined ? this.name : <any>null;
        data["code"] = this.code !== undefined ? this.code : <any>null;
        data["orderIndex"] = this.orderIndex !== undefined ? this.orderIndex : <any>null;
        data["casualDating"] = this.casualDating !== undefined ? this.casualDating : <any>null;
        super.toJSON(data);
        return data; 
    }

    clone(): DTOAdvertisementCategory {
        const json = this.toJSON();
        let result = new DTOAdvertisementCategory();
        result.init(json);
        return result;
    }
}

export interface IDTOAdvertisementCategory extends IDTOBaseModel {
    advertisementCategoryId: number;
    name?: string | null;
    code?: string | null;
    orderIndex: number;
    casualDating: boolean;
}

export class DTORegion extends DTOBaseModel implements IDTORegion {
    regionId!: number;
    shortName?: string | null;
    name?: string | null;
    isActive!: boolean;
    subRegions?: DTOSubRegion[] | null;

    constructor(data?: IDTORegion) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.regionId = _data["regionId"] !== undefined ? _data["regionId"] : <any>null;
            this.shortName = _data["shortName"] !== undefined ? _data["shortName"] : <any>null;
            this.name = _data["name"] !== undefined ? _data["name"] : <any>null;
            this.isActive = _data["isActive"] !== undefined ? _data["isActive"] : <any>null;
            if (Array.isArray(_data["subRegions"])) {
                this.subRegions = [] as any;
                for (let item of _data["subRegions"])
                    this.subRegions!.push(DTOSubRegion.fromJS(item));
            }
        }
    }

    static fromJS(data: any): DTORegion {
        data = typeof data === 'object' ? data : {};
        let result = new DTORegion();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["regionId"] = this.regionId !== undefined ? this.regionId : <any>null;
        data["shortName"] = this.shortName !== undefined ? this.shortName : <any>null;
        data["name"] = this.name !== undefined ? this.name : <any>null;
        data["isActive"] = this.isActive !== undefined ? this.isActive : <any>null;
        if (Array.isArray(this.subRegions)) {
            data["subRegions"] = [];
            for (let item of this.subRegions)
                data["subRegions"].push(item.toJSON());
        }
        super.toJSON(data);
        return data; 
    }

    clone(): DTORegion {
        const json = this.toJSON();
        let result = new DTORegion();
        result.init(json);
        return result;
    }
}

export interface IDTORegion extends IDTOBaseModel {
    regionId: number;
    shortName?: string | null;
    name?: string | null;
    isActive: boolean;
    subRegions?: DTOSubRegion[] | null;
}

export class DTOSubRegion extends DTOBaseModel implements IDTOSubRegion {
    subRegionId!: number;
    shortName?: string | null;
    shortRegionSubregion?: string | null;
    name?: string | null;
    isActive!: boolean;
    regionId!: number;
    zip?: string | null;

    constructor(data?: IDTOSubRegion) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.subRegionId = _data["subRegionId"] !== undefined ? _data["subRegionId"] : <any>null;
            this.shortName = _data["shortName"] !== undefined ? _data["shortName"] : <any>null;
            this.shortRegionSubregion = _data["shortRegionSubregion"] !== undefined ? _data["shortRegionSubregion"] : <any>null;
            this.name = _data["name"] !== undefined ? _data["name"] : <any>null;
            this.isActive = _data["isActive"] !== undefined ? _data["isActive"] : <any>null;
            this.regionId = _data["regionId"] !== undefined ? _data["regionId"] : <any>null;
            this.zip = _data["zip"] !== undefined ? _data["zip"] : <any>null;
        }
    }

    static fromJS(data: any): DTOSubRegion {
        data = typeof data === 'object' ? data : {};
        let result = new DTOSubRegion();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["subRegionId"] = this.subRegionId !== undefined ? this.subRegionId : <any>null;
        data["shortName"] = this.shortName !== undefined ? this.shortName : <any>null;
        data["shortRegionSubregion"] = this.shortRegionSubregion !== undefined ? this.shortRegionSubregion : <any>null;
        data["name"] = this.name !== undefined ? this.name : <any>null;
        data["isActive"] = this.isActive !== undefined ? this.isActive : <any>null;
        data["regionId"] = this.regionId !== undefined ? this.regionId : <any>null;
        data["zip"] = this.zip !== undefined ? this.zip : <any>null;
        super.toJSON(data);
        return data; 
    }

    clone(): DTOSubRegion {
        const json = this.toJSON();
        let result = new DTOSubRegion();
        result.init(json);
        return result;
    }
}

export interface IDTOSubRegion extends IDTOBaseModel {
    subRegionId: number;
    shortName?: string | null;
    shortRegionSubregion?: string | null;
    name?: string | null;
    isActive: boolean;
    regionId: number;
    zip?: string | null;
}

export class AdvertistmentRepostResponse extends ResponseBaseModel implements IAdvertistmentRepostResponse {
    isReposted!: boolean;

    constructor(data?: IAdvertistmentRepostResponse) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.isReposted = _data["isReposted"] !== undefined ? _data["isReposted"] : <any>null;
        }
    }

    static fromJS(data: any): AdvertistmentRepostResponse {
        data = typeof data === 'object' ? data : {};
        let result = new AdvertistmentRepostResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["isReposted"] = this.isReposted !== undefined ? this.isReposted : <any>null;
        super.toJSON(data);
        return data; 
    }

    clone(): AdvertistmentRepostResponse {
        const json = this.toJSON();
        let result = new AdvertistmentRepostResponse();
        result.init(json);
        return result;
    }
}

export interface IAdvertistmentRepostResponse extends IResponseBaseModel {
    isReposted: boolean;
}

export class DTOAdvertisement extends DTOBaseModel implements IDTOAdvertisement {
    advertisementId?: number | null;
    regionId?: number | null;
    seen!: boolean;
    seenAdmin!: boolean;
    subRegionId?: number | null;
    zipCode?: string | null;
    location?: string | null;
    dateStart?: moment.Moment | null;
    dateEnd?: moment.Moment | null;
    title?: string | null;
    content?: string | null;
    published?: boolean | null;
    casualDating?: boolean | null;
    advertisementCategoryId?: number | null;
    isPremium!: boolean;
    isPremiumUser?: boolean | null;
    regionName?: string | null;
    regionShortName?: string | null;
    subRegionName?: string | null;
    categoryCode?: string | null;
    images?: DTOAdvertisementImage[] | null;
    userId?: number | null;
    userNick?: string | null;
    moderated?: boolean | null;
    moderatedAt?: moment.Moment | null;
    moderatedBy?: number | null;
    moderateText?: string | null;
    age?: string | null;
    locationDescription?: string | null;
    isDemo!: boolean;
    showAs?: ShowAdType | null;

    constructor(data?: IDTOAdvertisement) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.advertisementId = _data["advertisementId"] !== undefined ? _data["advertisementId"] : <any>null;
            this.regionId = _data["regionId"] !== undefined ? _data["regionId"] : <any>null;
            this.seen = _data["seen"] !== undefined ? _data["seen"] : <any>null;
            this.seenAdmin = _data["seenAdmin"] !== undefined ? _data["seenAdmin"] : <any>null;
            this.subRegionId = _data["subRegionId"] !== undefined ? _data["subRegionId"] : <any>null;
            this.zipCode = _data["zipCode"] !== undefined ? _data["zipCode"] : <any>null;
            this.location = _data["location"] !== undefined ? _data["location"] : <any>null;
            this.dateStart = _data["dateStart"] ? moment(_data["dateStart"].toString()) : <any>null;
            this.dateEnd = _data["dateEnd"] ? moment(_data["dateEnd"].toString()) : <any>null;
            this.title = _data["title"] !== undefined ? _data["title"] : <any>null;
            this.content = _data["content"] !== undefined ? _data["content"] : <any>null;
            this.published = _data["published"] !== undefined ? _data["published"] : <any>null;
            this.casualDating = _data["casualDating"] !== undefined ? _data["casualDating"] : <any>null;
            this.advertisementCategoryId = _data["advertisementCategoryId"] !== undefined ? _data["advertisementCategoryId"] : <any>null;
            this.isPremium = _data["isPremium"] !== undefined ? _data["isPremium"] : <any>null;
            this.isPremiumUser = _data["isPremiumUser"] !== undefined ? _data["isPremiumUser"] : <any>null;
            this.regionName = _data["regionName"] !== undefined ? _data["regionName"] : <any>null;
            this.regionShortName = _data["regionShortName"] !== undefined ? _data["regionShortName"] : <any>null;
            this.subRegionName = _data["subRegionName"] !== undefined ? _data["subRegionName"] : <any>null;
            this.categoryCode = _data["categoryCode"] !== undefined ? _data["categoryCode"] : <any>null;
            if (Array.isArray(_data["images"])) {
                this.images = [] as any;
                for (let item of _data["images"])
                    this.images!.push(DTOAdvertisementImage.fromJS(item));
            }
            this.userId = _data["userId"] !== undefined ? _data["userId"] : <any>null;
            this.userNick = _data["userNick"] !== undefined ? _data["userNick"] : <any>null;
            this.moderated = _data["moderated"] !== undefined ? _data["moderated"] : <any>null;
            this.moderatedAt = _data["moderatedAt"] ? moment(_data["moderatedAt"].toString()) : <any>null;
            this.moderatedBy = _data["moderatedBy"] !== undefined ? _data["moderatedBy"] : <any>null;
            this.moderateText = _data["moderateText"] !== undefined ? _data["moderateText"] : <any>null;
            this.age = _data["age"] !== undefined ? _data["age"] : <any>null;
            this.locationDescription = _data["locationDescription"] !== undefined ? _data["locationDescription"] : <any>null;
            this.isDemo = _data["isDemo"] !== undefined ? _data["isDemo"] : <any>null;
            this.showAs = _data["showAs"] !== undefined ? _data["showAs"] : <any>null;
        }
    }

    static fromJS(data: any): DTOAdvertisement {
        data = typeof data === 'object' ? data : {};
        let result = new DTOAdvertisement();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["advertisementId"] = this.advertisementId !== undefined ? this.advertisementId : <any>null;
        data["regionId"] = this.regionId !== undefined ? this.regionId : <any>null;
        data["seen"] = this.seen !== undefined ? this.seen : <any>null;
        data["seenAdmin"] = this.seenAdmin !== undefined ? this.seenAdmin : <any>null;
        data["subRegionId"] = this.subRegionId !== undefined ? this.subRegionId : <any>null;
        data["zipCode"] = this.zipCode !== undefined ? this.zipCode : <any>null;
        data["location"] = this.location !== undefined ? this.location : <any>null;
        data["dateStart"] = this.dateStart ? this.dateStart.toISOString() : <any>null;
        data["dateEnd"] = this.dateEnd ? this.dateEnd.toISOString() : <any>null;
        data["title"] = this.title !== undefined ? this.title : <any>null;
        data["content"] = this.content !== undefined ? this.content : <any>null;
        data["published"] = this.published !== undefined ? this.published : <any>null;
        data["casualDating"] = this.casualDating !== undefined ? this.casualDating : <any>null;
        data["advertisementCategoryId"] = this.advertisementCategoryId !== undefined ? this.advertisementCategoryId : <any>null;
        data["isPremium"] = this.isPremium !== undefined ? this.isPremium : <any>null;
        data["isPremiumUser"] = this.isPremiumUser !== undefined ? this.isPremiumUser : <any>null;
        data["regionName"] = this.regionName !== undefined ? this.regionName : <any>null;
        data["regionShortName"] = this.regionShortName !== undefined ? this.regionShortName : <any>null;
        data["subRegionName"] = this.subRegionName !== undefined ? this.subRegionName : <any>null;
        data["categoryCode"] = this.categoryCode !== undefined ? this.categoryCode : <any>null;
        if (Array.isArray(this.images)) {
            data["images"] = [];
            for (let item of this.images)
                data["images"].push(item.toJSON());
        }
        data["userId"] = this.userId !== undefined ? this.userId : <any>null;
        data["userNick"] = this.userNick !== undefined ? this.userNick : <any>null;
        data["moderated"] = this.moderated !== undefined ? this.moderated : <any>null;
        data["moderatedAt"] = this.moderatedAt ? this.moderatedAt.toISOString() : <any>null;
        data["moderatedBy"] = this.moderatedBy !== undefined ? this.moderatedBy : <any>null;
        data["moderateText"] = this.moderateText !== undefined ? this.moderateText : <any>null;
        data["age"] = this.age !== undefined ? this.age : <any>null;
        data["locationDescription"] = this.locationDescription !== undefined ? this.locationDescription : <any>null;
        data["isDemo"] = this.isDemo !== undefined ? this.isDemo : <any>null;
        data["showAs"] = this.showAs !== undefined ? this.showAs : <any>null;
        super.toJSON(data);
        return data; 
    }

    clone(): DTOAdvertisement {
        const json = this.toJSON();
        let result = new DTOAdvertisement();
        result.init(json);
        return result;
    }
}

export interface IDTOAdvertisement extends IDTOBaseModel {
    advertisementId?: number | null;
    regionId?: number | null;
    seen: boolean;
    seenAdmin: boolean;
    subRegionId?: number | null;
    zipCode?: string | null;
    location?: string | null;
    dateStart?: moment.Moment | null;
    dateEnd?: moment.Moment | null;
    title?: string | null;
    content?: string | null;
    published?: boolean | null;
    casualDating?: boolean | null;
    advertisementCategoryId?: number | null;
    isPremium: boolean;
    isPremiumUser?: boolean | null;
    regionName?: string | null;
    regionShortName?: string | null;
    subRegionName?: string | null;
    categoryCode?: string | null;
    images?: DTOAdvertisementImage[] | null;
    userId?: number | null;
    userNick?: string | null;
    moderated?: boolean | null;
    moderatedAt?: moment.Moment | null;
    moderatedBy?: number | null;
    moderateText?: string | null;
    age?: string | null;
    locationDescription?: string | null;
    isDemo: boolean;
    showAs?: ShowAdType | null;
}

export class AdveristmentCreateModel extends DTOAdvertisement implements IAdveristmentCreateModel {

    constructor(data?: IAdveristmentCreateModel) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
    }

    static fromJS(data: any): AdveristmentCreateModel {
        data = typeof data === 'object' ? data : {};
        let result = new AdveristmentCreateModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data; 
    }

    clone(): AdveristmentCreateModel {
        const json = this.toJSON();
        let result = new AdveristmentCreateModel();
        result.init(json);
        return result;
    }
}

export interface IAdveristmentCreateModel extends IDTOAdvertisement {
}

export class AdveristmentUpdateModel extends AdveristmentCreateModel implements IAdveristmentUpdateModel {
    manageId?: string | null;

    constructor(data?: IAdveristmentUpdateModel) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.manageId = _data["manageId"] !== undefined ? _data["manageId"] : <any>null;
        }
    }

    static fromJS(data: any): AdveristmentUpdateModel {
        data = typeof data === 'object' ? data : {};
        let result = new AdveristmentUpdateModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["manageId"] = this.manageId !== undefined ? this.manageId : <any>null;
        super.toJSON(data);
        return data; 
    }

    clone(): AdveristmentUpdateModel {
        const json = this.toJSON();
        let result = new AdveristmentUpdateModel();
        result.init(json);
        return result;
    }
}

export interface IAdveristmentUpdateModel extends IAdveristmentCreateModel {
    manageId?: string | null;
}

export class AdvertistmentRepostModel extends AdveristmentUpdateModel implements IAdvertistmentRepostModel {

    constructor(data?: IAdvertistmentRepostModel) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
    }

    static fromJS(data: any): AdvertistmentRepostModel {
        data = typeof data === 'object' ? data : {};
        let result = new AdvertistmentRepostModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data; 
    }

    clone(): AdvertistmentRepostModel {
        const json = this.toJSON();
        let result = new AdvertistmentRepostModel();
        result.init(json);
        return result;
    }
}

export interface IAdvertistmentRepostModel extends IAdveristmentUpdateModel {
}

export class DTOAdvertisementImage extends DTOBaseModel implements IDTOAdvertisementImage {
    advertisementImageId?: number | null;
    advertisementId?: number | null;
    name?: string | null;
    fileName?: string | null;
    orgFileName?: string | null;
    tempFileName?: string | null;
    orderIndex?: number | null;
    isMain?: boolean | null;

    constructor(data?: IDTOAdvertisementImage) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.advertisementImageId = _data["advertisementImageId"] !== undefined ? _data["advertisementImageId"] : <any>null;
            this.advertisementId = _data["advertisementId"] !== undefined ? _data["advertisementId"] : <any>null;
            this.name = _data["name"] !== undefined ? _data["name"] : <any>null;
            this.fileName = _data["fileName"] !== undefined ? _data["fileName"] : <any>null;
            this.orgFileName = _data["orgFileName"] !== undefined ? _data["orgFileName"] : <any>null;
            this.tempFileName = _data["tempFileName"] !== undefined ? _data["tempFileName"] : <any>null;
            this.orderIndex = _data["orderIndex"] !== undefined ? _data["orderIndex"] : <any>null;
            this.isMain = _data["isMain"] !== undefined ? _data["isMain"] : <any>null;
        }
    }

    static fromJS(data: any): DTOAdvertisementImage {
        data = typeof data === 'object' ? data : {};
        let result = new DTOAdvertisementImage();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["advertisementImageId"] = this.advertisementImageId !== undefined ? this.advertisementImageId : <any>null;
        data["advertisementId"] = this.advertisementId !== undefined ? this.advertisementId : <any>null;
        data["name"] = this.name !== undefined ? this.name : <any>null;
        data["fileName"] = this.fileName !== undefined ? this.fileName : <any>null;
        data["orgFileName"] = this.orgFileName !== undefined ? this.orgFileName : <any>null;
        data["tempFileName"] = this.tempFileName !== undefined ? this.tempFileName : <any>null;
        data["orderIndex"] = this.orderIndex !== undefined ? this.orderIndex : <any>null;
        data["isMain"] = this.isMain !== undefined ? this.isMain : <any>null;
        super.toJSON(data);
        return data; 
    }

    clone(): DTOAdvertisementImage {
        const json = this.toJSON();
        let result = new DTOAdvertisementImage();
        result.init(json);
        return result;
    }
}

export interface IDTOAdvertisementImage extends IDTOBaseModel {
    advertisementImageId?: number | null;
    advertisementId?: number | null;
    name?: string | null;
    fileName?: string | null;
    orgFileName?: string | null;
    tempFileName?: string | null;
    orderIndex?: number | null;
    isMain?: boolean | null;
}

export enum ShowAdType {
    NotSet = 0,
    PremiumAd = 1,
    PremiumUser = 2,
    StandardAd = 3,
}

export class AdveristmentCreateResponse extends ResponseBaseModel implements IAdveristmentCreateResponse {
    advertisementId!: number;

    constructor(data?: IAdveristmentCreateResponse) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.advertisementId = _data["advertisementId"] !== undefined ? _data["advertisementId"] : <any>null;
        }
    }

    static fromJS(data: any): AdveristmentCreateResponse {
        data = typeof data === 'object' ? data : {};
        let result = new AdveristmentCreateResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["advertisementId"] = this.advertisementId !== undefined ? this.advertisementId : <any>null;
        super.toJSON(data);
        return data; 
    }

    clone(): AdveristmentCreateResponse {
        const json = this.toJSON();
        let result = new AdveristmentCreateResponse();
        result.init(json);
        return result;
    }
}

export interface IAdveristmentCreateResponse extends IResponseBaseModel {
    advertisementId: number;
}

export class AdveristmentUpdateResponse extends AdveristmentCreateResponse implements IAdveristmentUpdateResponse {

    constructor(data?: IAdveristmentUpdateResponse) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
    }

    static fromJS(data: any): AdveristmentUpdateResponse {
        data = typeof data === 'object' ? data : {};
        let result = new AdveristmentUpdateResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data; 
    }

    clone(): AdveristmentUpdateResponse {
        const json = this.toJSON();
        let result = new AdveristmentUpdateResponse();
        result.init(json);
        return result;
    }
}

export interface IAdveristmentUpdateResponse extends IAdveristmentCreateResponse {
}

export class AdveristmentDeleteResponse extends AdveristmentCreateResponse implements IAdveristmentDeleteResponse {

    constructor(data?: IAdveristmentDeleteResponse) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
    }

    static fromJS(data: any): AdveristmentDeleteResponse {
        data = typeof data === 'object' ? data : {};
        let result = new AdveristmentDeleteResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data; 
    }

    clone(): AdveristmentDeleteResponse {
        const json = this.toJSON();
        let result = new AdveristmentDeleteResponse();
        result.init(json);
        return result;
    }
}

export interface IAdveristmentDeleteResponse extends IAdveristmentCreateResponse {
}

export class AdveristmentDeleteModel implements IAdveristmentDeleteModel {
    advertisementId!: number;

    constructor(data?: IAdveristmentDeleteModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.advertisementId = _data["advertisementId"] !== undefined ? _data["advertisementId"] : <any>null;
        }
    }

    static fromJS(data: any): AdveristmentDeleteModel {
        data = typeof data === 'object' ? data : {};
        let result = new AdveristmentDeleteModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["advertisementId"] = this.advertisementId !== undefined ? this.advertisementId : <any>null;
        return data; 
    }

    clone(): AdveristmentDeleteModel {
        const json = this.toJSON();
        let result = new AdveristmentDeleteModel();
        result.init(json);
        return result;
    }
}

export interface IAdveristmentDeleteModel {
    advertisementId: number;
}

export class AdveristmentGetResponse extends ResponseBaseModel implements IAdveristmentGetResponse {
    adveristments?: DTOAdvertisement[] | null;
    totalResultsCount?: number | null;
    regionShortName?: string | null;
    subRegionName?: string | null;
    closestSubregionNameIfNoResult?: string | null;

    constructor(data?: IAdveristmentGetResponse) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["adveristments"])) {
                this.adveristments = [] as any;
                for (let item of _data["adveristments"])
                    this.adveristments!.push(DTOAdvertisement.fromJS(item));
            }
            this.totalResultsCount = _data["totalResultsCount"] !== undefined ? _data["totalResultsCount"] : <any>null;
            this.regionShortName = _data["regionShortName"] !== undefined ? _data["regionShortName"] : <any>null;
            this.subRegionName = _data["subRegionName"] !== undefined ? _data["subRegionName"] : <any>null;
            this.closestSubregionNameIfNoResult = _data["closestSubregionNameIfNoResult"] !== undefined ? _data["closestSubregionNameIfNoResult"] : <any>null;
        }
    }

    static fromJS(data: any): AdveristmentGetResponse {
        data = typeof data === 'object' ? data : {};
        let result = new AdveristmentGetResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.adveristments)) {
            data["adveristments"] = [];
            for (let item of this.adveristments)
                data["adveristments"].push(item.toJSON());
        }
        data["totalResultsCount"] = this.totalResultsCount !== undefined ? this.totalResultsCount : <any>null;
        data["regionShortName"] = this.regionShortName !== undefined ? this.regionShortName : <any>null;
        data["subRegionName"] = this.subRegionName !== undefined ? this.subRegionName : <any>null;
        data["closestSubregionNameIfNoResult"] = this.closestSubregionNameIfNoResult !== undefined ? this.closestSubregionNameIfNoResult : <any>null;
        super.toJSON(data);
        return data; 
    }

    clone(): AdveristmentGetResponse {
        const json = this.toJSON();
        let result = new AdveristmentGetResponse();
        result.init(json);
        return result;
    }
}

export interface IAdveristmentGetResponse extends IResponseBaseModel {
    adveristments?: DTOAdvertisement[] | null;
    totalResultsCount?: number | null;
    regionShortName?: string | null;
    subRegionName?: string | null;
    closestSubregionNameIfNoResult?: string | null;
}

export class AdveristmentGetModel implements IAdveristmentGetModel {
    byId?: number | null;
    userId?: number | null;
    pageNumber?: number | null;
    pageSize?: number | null;
    nonDemoOnly?: boolean | null;
    regionId?: number | null;
    subRegionId?: number | null;
    zipCode?: string | null;
    miles?: number | null;
    keywords?: string | null;
    withPicturesOnly?: boolean | null;
    showActive?: boolean | null;
    showExpired?: boolean | null;
    casualDating?: boolean | null;
    advertisementCategoryId?: number | null;
    title?: string | null;
    content?: string | null;
    manageId?: string | null;
    age?: string | null;
    locationDescription?: string | null;

    constructor(data?: IAdveristmentGetModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.byId = _data["byId"] !== undefined ? _data["byId"] : <any>null;
            this.userId = _data["userId"] !== undefined ? _data["userId"] : <any>null;
            this.pageNumber = _data["pageNumber"] !== undefined ? _data["pageNumber"] : <any>null;
            this.pageSize = _data["pageSize"] !== undefined ? _data["pageSize"] : <any>null;
            this.nonDemoOnly = _data["nonDemoOnly"] !== undefined ? _data["nonDemoOnly"] : <any>null;
            this.regionId = _data["regionId"] !== undefined ? _data["regionId"] : <any>null;
            this.subRegionId = _data["subRegionId"] !== undefined ? _data["subRegionId"] : <any>null;
            this.zipCode = _data["zipCode"] !== undefined ? _data["zipCode"] : <any>null;
            this.miles = _data["miles"] !== undefined ? _data["miles"] : <any>null;
            this.keywords = _data["keywords"] !== undefined ? _data["keywords"] : <any>null;
            this.withPicturesOnly = _data["withPicturesOnly"] !== undefined ? _data["withPicturesOnly"] : <any>null;
            this.showActive = _data["showActive"] !== undefined ? _data["showActive"] : <any>null;
            this.showExpired = _data["showExpired"] !== undefined ? _data["showExpired"] : <any>null;
            this.casualDating = _data["casualDating"] !== undefined ? _data["casualDating"] : <any>null;
            this.advertisementCategoryId = _data["advertisementCategoryId"] !== undefined ? _data["advertisementCategoryId"] : <any>null;
            this.title = _data["title"] !== undefined ? _data["title"] : <any>null;
            this.content = _data["content"] !== undefined ? _data["content"] : <any>null;
            this.manageId = _data["manageId"] !== undefined ? _data["manageId"] : <any>null;
            this.age = _data["age"] !== undefined ? _data["age"] : <any>null;
            this.locationDescription = _data["locationDescription"] !== undefined ? _data["locationDescription"] : <any>null;
        }
    }

    static fromJS(data: any): AdveristmentGetModel {
        data = typeof data === 'object' ? data : {};
        let result = new AdveristmentGetModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["byId"] = this.byId !== undefined ? this.byId : <any>null;
        data["userId"] = this.userId !== undefined ? this.userId : <any>null;
        data["pageNumber"] = this.pageNumber !== undefined ? this.pageNumber : <any>null;
        data["pageSize"] = this.pageSize !== undefined ? this.pageSize : <any>null;
        data["nonDemoOnly"] = this.nonDemoOnly !== undefined ? this.nonDemoOnly : <any>null;
        data["regionId"] = this.regionId !== undefined ? this.regionId : <any>null;
        data["subRegionId"] = this.subRegionId !== undefined ? this.subRegionId : <any>null;
        data["zipCode"] = this.zipCode !== undefined ? this.zipCode : <any>null;
        data["miles"] = this.miles !== undefined ? this.miles : <any>null;
        data["keywords"] = this.keywords !== undefined ? this.keywords : <any>null;
        data["withPicturesOnly"] = this.withPicturesOnly !== undefined ? this.withPicturesOnly : <any>null;
        data["showActive"] = this.showActive !== undefined ? this.showActive : <any>null;
        data["showExpired"] = this.showExpired !== undefined ? this.showExpired : <any>null;
        data["casualDating"] = this.casualDating !== undefined ? this.casualDating : <any>null;
        data["advertisementCategoryId"] = this.advertisementCategoryId !== undefined ? this.advertisementCategoryId : <any>null;
        data["title"] = this.title !== undefined ? this.title : <any>null;
        data["content"] = this.content !== undefined ? this.content : <any>null;
        data["manageId"] = this.manageId !== undefined ? this.manageId : <any>null;
        data["age"] = this.age !== undefined ? this.age : <any>null;
        data["locationDescription"] = this.locationDescription !== undefined ? this.locationDescription : <any>null;
        return data; 
    }

    clone(): AdveristmentGetModel {
        const json = this.toJSON();
        let result = new AdveristmentGetModel();
        result.init(json);
        return result;
    }
}

export interface IAdveristmentGetModel {
    byId?: number | null;
    userId?: number | null;
    pageNumber?: number | null;
    pageSize?: number | null;
    nonDemoOnly?: boolean | null;
    regionId?: number | null;
    subRegionId?: number | null;
    zipCode?: string | null;
    miles?: number | null;
    keywords?: string | null;
    withPicturesOnly?: boolean | null;
    showActive?: boolean | null;
    showExpired?: boolean | null;
    casualDating?: boolean | null;
    advertisementCategoryId?: number | null;
    title?: string | null;
    content?: string | null;
    manageId?: string | null;
    age?: string | null;
    locationDescription?: string | null;
}

export class AdWritterInformationResponse extends ResponseBaseModel implements IAdWritterInformationResponse {
    isSend!: boolean;

    constructor(data?: IAdWritterInformationResponse) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.isSend = _data["isSend"] !== undefined ? _data["isSend"] : <any>null;
        }
    }

    static fromJS(data: any): AdWritterInformationResponse {
        data = typeof data === 'object' ? data : {};
        let result = new AdWritterInformationResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["isSend"] = this.isSend !== undefined ? this.isSend : <any>null;
        super.toJSON(data);
        return data; 
    }

    clone(): AdWritterInformationResponse {
        const json = this.toJSON();
        let result = new AdWritterInformationResponse();
        result.init(json);
        return result;
    }
}

export interface IAdWritterInformationResponse extends IResponseBaseModel {
    isSend: boolean;
}

export class AdWritterInformationRequest implements IAdWritterInformationRequest {
    name?: string | null;
    age?: string | null;
    gender?: string | null;
    lookingFor?: string | null;
    height?: string | null;
    weight?: string | null;
    bodyType?: string | null;
    race?: string | null;
    idealMatch?: string | null;
    lookingForRelationship?: string | null;
    thingsInFreeTime?: string | null;
    aspectsOfLife?: string | null;
    dontLike?: string | null;
    passions?: string | null;
    occupation?: string | null;
    characteristics?: string | null;
    goalsAndDreams?: string | null;
    thankfullFor?: string | null;
    kids?: string | null;
    education?: string | null;
    workout?: string | null;
    travel?: string | null;
    healthyFood?: string | null;
    smoke?: string | null;
    alcohol?: string | null;
    email?: string | null;

    constructor(data?: IAdWritterInformationRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"] !== undefined ? _data["name"] : <any>null;
            this.age = _data["age"] !== undefined ? _data["age"] : <any>null;
            this.gender = _data["gender"] !== undefined ? _data["gender"] : <any>null;
            this.lookingFor = _data["lookingFor"] !== undefined ? _data["lookingFor"] : <any>null;
            this.height = _data["height"] !== undefined ? _data["height"] : <any>null;
            this.weight = _data["weight"] !== undefined ? _data["weight"] : <any>null;
            this.bodyType = _data["bodyType"] !== undefined ? _data["bodyType"] : <any>null;
            this.race = _data["race"] !== undefined ? _data["race"] : <any>null;
            this.idealMatch = _data["idealMatch"] !== undefined ? _data["idealMatch"] : <any>null;
            this.lookingForRelationship = _data["lookingForRelationship"] !== undefined ? _data["lookingForRelationship"] : <any>null;
            this.thingsInFreeTime = _data["thingsInFreeTime"] !== undefined ? _data["thingsInFreeTime"] : <any>null;
            this.aspectsOfLife = _data["aspectsOfLife"] !== undefined ? _data["aspectsOfLife"] : <any>null;
            this.dontLike = _data["dontLike"] !== undefined ? _data["dontLike"] : <any>null;
            this.passions = _data["passions"] !== undefined ? _data["passions"] : <any>null;
            this.occupation = _data["occupation"] !== undefined ? _data["occupation"] : <any>null;
            this.characteristics = _data["characteristics"] !== undefined ? _data["characteristics"] : <any>null;
            this.goalsAndDreams = _data["goalsAndDreams"] !== undefined ? _data["goalsAndDreams"] : <any>null;
            this.thankfullFor = _data["thankfullFor"] !== undefined ? _data["thankfullFor"] : <any>null;
            this.kids = _data["kids"] !== undefined ? _data["kids"] : <any>null;
            this.education = _data["education"] !== undefined ? _data["education"] : <any>null;
            this.workout = _data["workout"] !== undefined ? _data["workout"] : <any>null;
            this.travel = _data["travel"] !== undefined ? _data["travel"] : <any>null;
            this.healthyFood = _data["healthyFood"] !== undefined ? _data["healthyFood"] : <any>null;
            this.smoke = _data["smoke"] !== undefined ? _data["smoke"] : <any>null;
            this.alcohol = _data["alcohol"] !== undefined ? _data["alcohol"] : <any>null;
            this.email = _data["email"] !== undefined ? _data["email"] : <any>null;
        }
    }

    static fromJS(data: any): AdWritterInformationRequest {
        data = typeof data === 'object' ? data : {};
        let result = new AdWritterInformationRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name !== undefined ? this.name : <any>null;
        data["age"] = this.age !== undefined ? this.age : <any>null;
        data["gender"] = this.gender !== undefined ? this.gender : <any>null;
        data["lookingFor"] = this.lookingFor !== undefined ? this.lookingFor : <any>null;
        data["height"] = this.height !== undefined ? this.height : <any>null;
        data["weight"] = this.weight !== undefined ? this.weight : <any>null;
        data["bodyType"] = this.bodyType !== undefined ? this.bodyType : <any>null;
        data["race"] = this.race !== undefined ? this.race : <any>null;
        data["idealMatch"] = this.idealMatch !== undefined ? this.idealMatch : <any>null;
        data["lookingForRelationship"] = this.lookingForRelationship !== undefined ? this.lookingForRelationship : <any>null;
        data["thingsInFreeTime"] = this.thingsInFreeTime !== undefined ? this.thingsInFreeTime : <any>null;
        data["aspectsOfLife"] = this.aspectsOfLife !== undefined ? this.aspectsOfLife : <any>null;
        data["dontLike"] = this.dontLike !== undefined ? this.dontLike : <any>null;
        data["passions"] = this.passions !== undefined ? this.passions : <any>null;
        data["occupation"] = this.occupation !== undefined ? this.occupation : <any>null;
        data["characteristics"] = this.characteristics !== undefined ? this.characteristics : <any>null;
        data["goalsAndDreams"] = this.goalsAndDreams !== undefined ? this.goalsAndDreams : <any>null;
        data["thankfullFor"] = this.thankfullFor !== undefined ? this.thankfullFor : <any>null;
        data["kids"] = this.kids !== undefined ? this.kids : <any>null;
        data["education"] = this.education !== undefined ? this.education : <any>null;
        data["workout"] = this.workout !== undefined ? this.workout : <any>null;
        data["travel"] = this.travel !== undefined ? this.travel : <any>null;
        data["healthyFood"] = this.healthyFood !== undefined ? this.healthyFood : <any>null;
        data["smoke"] = this.smoke !== undefined ? this.smoke : <any>null;
        data["alcohol"] = this.alcohol !== undefined ? this.alcohol : <any>null;
        data["email"] = this.email !== undefined ? this.email : <any>null;
        return data; 
    }

    clone(): AdWritterInformationRequest {
        const json = this.toJSON();
        let result = new AdWritterInformationRequest();
        result.init(json);
        return result;
    }
}

export interface IAdWritterInformationRequest {
    name?: string | null;
    age?: string | null;
    gender?: string | null;
    lookingFor?: string | null;
    height?: string | null;
    weight?: string | null;
    bodyType?: string | null;
    race?: string | null;
    idealMatch?: string | null;
    lookingForRelationship?: string | null;
    thingsInFreeTime?: string | null;
    aspectsOfLife?: string | null;
    dontLike?: string | null;
    passions?: string | null;
    occupation?: string | null;
    characteristics?: string | null;
    goalsAndDreams?: string | null;
    thankfullFor?: string | null;
    kids?: string | null;
    education?: string | null;
    workout?: string | null;
    travel?: string | null;
    healthyFood?: string | null;
    smoke?: string | null;
    alcohol?: string | null;
    email?: string | null;
}

export class LoginResponseModel extends ResponseBaseModel implements ILoginResponseModel {
    token?: string | null;
    isDemo!: boolean;
    phoneVerificationRequired!: boolean;
    userId!: number;
    userPhone?: string | null;

    constructor(data?: ILoginResponseModel) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.token = _data["token"] !== undefined ? _data["token"] : <any>null;
            this.isDemo = _data["isDemo"] !== undefined ? _data["isDemo"] : <any>null;
            this.phoneVerificationRequired = _data["phoneVerificationRequired"] !== undefined ? _data["phoneVerificationRequired"] : <any>null;
            this.userId = _data["userId"] !== undefined ? _data["userId"] : <any>null;
            this.userPhone = _data["userPhone"] !== undefined ? _data["userPhone"] : <any>null;
        }
    }

    static fromJS(data: any): LoginResponseModel {
        data = typeof data === 'object' ? data : {};
        let result = new LoginResponseModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["token"] = this.token !== undefined ? this.token : <any>null;
        data["isDemo"] = this.isDemo !== undefined ? this.isDemo : <any>null;
        data["phoneVerificationRequired"] = this.phoneVerificationRequired !== undefined ? this.phoneVerificationRequired : <any>null;
        data["userId"] = this.userId !== undefined ? this.userId : <any>null;
        data["userPhone"] = this.userPhone !== undefined ? this.userPhone : <any>null;
        super.toJSON(data);
        return data; 
    }

    clone(): LoginResponseModel {
        const json = this.toJSON();
        let result = new LoginResponseModel();
        result.init(json);
        return result;
    }
}

export interface ILoginResponseModel extends IResponseBaseModel {
    token?: string | null;
    isDemo: boolean;
    phoneVerificationRequired: boolean;
    userId: number;
    userPhone?: string | null;
}

export class LoginModel implements ILoginModel {
    userName?: string | null;
    password?: string | null;

    constructor(data?: ILoginModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.userName = _data["userName"] !== undefined ? _data["userName"] : <any>null;
            this.password = _data["password"] !== undefined ? _data["password"] : <any>null;
        }
    }

    static fromJS(data: any): LoginModel {
        data = typeof data === 'object' ? data : {};
        let result = new LoginModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userName"] = this.userName !== undefined ? this.userName : <any>null;
        data["password"] = this.password !== undefined ? this.password : <any>null;
        return data; 
    }

    clone(): LoginModel {
        const json = this.toJSON();
        let result = new LoginModel();
        result.init(json);
        return result;
    }
}

export interface ILoginModel {
    userName?: string | null;
    password?: string | null;
}

export class ConversationDeleteResponseModel extends ResponseBaseModel implements IConversationDeleteResponseModel {

    constructor(data?: IConversationDeleteResponseModel) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
    }

    static fromJS(data: any): ConversationDeleteResponseModel {
        data = typeof data === 'object' ? data : {};
        let result = new ConversationDeleteResponseModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data; 
    }

    clone(): ConversationDeleteResponseModel {
        const json = this.toJSON();
        let result = new ConversationDeleteResponseModel();
        result.init(json);
        return result;
    }
}

export interface IConversationDeleteResponseModel extends IResponseBaseModel {
}

export class ConversationDeleteRequestModel implements IConversationDeleteRequestModel {
    conversationId!: number;

    constructor(data?: IConversationDeleteRequestModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.conversationId = _data["conversationId"] !== undefined ? _data["conversationId"] : <any>null;
        }
    }

    static fromJS(data: any): ConversationDeleteRequestModel {
        data = typeof data === 'object' ? data : {};
        let result = new ConversationDeleteRequestModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["conversationId"] = this.conversationId !== undefined ? this.conversationId : <any>null;
        return data; 
    }

    clone(): ConversationDeleteRequestModel {
        const json = this.toJSON();
        let result = new ConversationDeleteRequestModel();
        result.init(json);
        return result;
    }
}

export interface IConversationDeleteRequestModel {
    conversationId: number;
}

export class GetConversationResponseModel extends ResponseBaseModel implements IGetConversationResponseModel {
    conversation?: DTOConversation | null;

    constructor(data?: IGetConversationResponseModel) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.conversation = _data["conversation"] ? DTOConversation.fromJS(_data["conversation"]) : <any>null;
        }
    }

    static fromJS(data: any): GetConversationResponseModel {
        data = typeof data === 'object' ? data : {};
        let result = new GetConversationResponseModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["conversation"] = this.conversation ? this.conversation.toJSON() : <any>null;
        super.toJSON(data);
        return data; 
    }

    clone(): GetConversationResponseModel {
        const json = this.toJSON();
        let result = new GetConversationResponseModel();
        result.init(json);
        return result;
    }
}

export interface IGetConversationResponseModel extends IResponseBaseModel {
    conversation?: DTOConversation | null;
}

export class DTOConversation implements IDTOConversation {
    conversationId!: number;
    senderId!: number;
    receiverId!: number;
    conversationKey?: string | null;
    senderNick?: string | null;
    creationDate!: moment.Moment;
    receiverNick?: string | null;
    advTitle?: string | null;
    advertisementId!: number;
    demoAdvertisement!: boolean;
    hasNewMessages!: boolean;
    messages?: DTOConversationMessage[] | null;

    constructor(data?: IDTOConversation) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.conversationId = _data["conversationId"] !== undefined ? _data["conversationId"] : <any>null;
            this.senderId = _data["senderId"] !== undefined ? _data["senderId"] : <any>null;
            this.receiverId = _data["receiverId"] !== undefined ? _data["receiverId"] : <any>null;
            this.conversationKey = _data["conversationKey"] !== undefined ? _data["conversationKey"] : <any>null;
            this.senderNick = _data["senderNick"] !== undefined ? _data["senderNick"] : <any>null;
            this.creationDate = _data["creationDate"] ? moment(_data["creationDate"].toString()) : <any>null;
            this.receiverNick = _data["receiverNick"] !== undefined ? _data["receiverNick"] : <any>null;
            this.advTitle = _data["advTitle"] !== undefined ? _data["advTitle"] : <any>null;
            this.advertisementId = _data["advertisementId"] !== undefined ? _data["advertisementId"] : <any>null;
            this.demoAdvertisement = _data["demoAdvertisement"] !== undefined ? _data["demoAdvertisement"] : <any>null;
            this.hasNewMessages = _data["hasNewMessages"] !== undefined ? _data["hasNewMessages"] : <any>null;
            if (Array.isArray(_data["messages"])) {
                this.messages = [] as any;
                for (let item of _data["messages"])
                    this.messages!.push(DTOConversationMessage.fromJS(item));
            }
        }
    }

    static fromJS(data: any): DTOConversation {
        data = typeof data === 'object' ? data : {};
        let result = new DTOConversation();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["conversationId"] = this.conversationId !== undefined ? this.conversationId : <any>null;
        data["senderId"] = this.senderId !== undefined ? this.senderId : <any>null;
        data["receiverId"] = this.receiverId !== undefined ? this.receiverId : <any>null;
        data["conversationKey"] = this.conversationKey !== undefined ? this.conversationKey : <any>null;
        data["senderNick"] = this.senderNick !== undefined ? this.senderNick : <any>null;
        data["creationDate"] = this.creationDate ? this.creationDate.toISOString() : <any>null;
        data["receiverNick"] = this.receiverNick !== undefined ? this.receiverNick : <any>null;
        data["advTitle"] = this.advTitle !== undefined ? this.advTitle : <any>null;
        data["advertisementId"] = this.advertisementId !== undefined ? this.advertisementId : <any>null;
        data["demoAdvertisement"] = this.demoAdvertisement !== undefined ? this.demoAdvertisement : <any>null;
        data["hasNewMessages"] = this.hasNewMessages !== undefined ? this.hasNewMessages : <any>null;
        if (Array.isArray(this.messages)) {
            data["messages"] = [];
            for (let item of this.messages)
                data["messages"].push(item.toJSON());
        }
        return data; 
    }

    clone(): DTOConversation {
        const json = this.toJSON();
        let result = new DTOConversation();
        result.init(json);
        return result;
    }
}

export interface IDTOConversation {
    conversationId: number;
    senderId: number;
    receiverId: number;
    conversationKey?: string | null;
    senderNick?: string | null;
    creationDate: moment.Moment;
    receiverNick?: string | null;
    advTitle?: string | null;
    advertisementId: number;
    demoAdvertisement: boolean;
    hasNewMessages: boolean;
    messages?: DTOConversationMessage[] | null;
}

export class DTOConversationMessage implements IDTOConversationMessage {
    conversationMessageId!: number;
    content?: string | null;
    senderId!: number;
    creationDate!: moment.Moment;
    title?: string | null;
    isRead!: boolean;
    images?: DTOConversationImage[] | null;

    constructor(data?: IDTOConversationMessage) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.conversationMessageId = _data["conversationMessageId"] !== undefined ? _data["conversationMessageId"] : <any>null;
            this.content = _data["content"] !== undefined ? _data["content"] : <any>null;
            this.senderId = _data["senderId"] !== undefined ? _data["senderId"] : <any>null;
            this.creationDate = _data["creationDate"] ? moment(_data["creationDate"].toString()) : <any>null;
            this.title = _data["title"] !== undefined ? _data["title"] : <any>null;
            this.isRead = _data["isRead"] !== undefined ? _data["isRead"] : <any>null;
            if (Array.isArray(_data["images"])) {
                this.images = [] as any;
                for (let item of _data["images"])
                    this.images!.push(DTOConversationImage.fromJS(item));
            }
        }
    }

    static fromJS(data: any): DTOConversationMessage {
        data = typeof data === 'object' ? data : {};
        let result = new DTOConversationMessage();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["conversationMessageId"] = this.conversationMessageId !== undefined ? this.conversationMessageId : <any>null;
        data["content"] = this.content !== undefined ? this.content : <any>null;
        data["senderId"] = this.senderId !== undefined ? this.senderId : <any>null;
        data["creationDate"] = this.creationDate ? this.creationDate.toISOString() : <any>null;
        data["title"] = this.title !== undefined ? this.title : <any>null;
        data["isRead"] = this.isRead !== undefined ? this.isRead : <any>null;
        if (Array.isArray(this.images)) {
            data["images"] = [];
            for (let item of this.images)
                data["images"].push(item.toJSON());
        }
        return data; 
    }

    clone(): DTOConversationMessage {
        const json = this.toJSON();
        let result = new DTOConversationMessage();
        result.init(json);
        return result;
    }
}

export interface IDTOConversationMessage {
    conversationMessageId: number;
    content?: string | null;
    senderId: number;
    creationDate: moment.Moment;
    title?: string | null;
    isRead: boolean;
    images?: DTOConversationImage[] | null;
}

export class DTOConversationImage implements IDTOConversationImage {
    conversationImageId!: number;
    name?: string | null;
    fileName?: string | null;

    constructor(data?: IDTOConversationImage) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.conversationImageId = _data["conversationImageId"] !== undefined ? _data["conversationImageId"] : <any>null;
            this.name = _data["name"] !== undefined ? _data["name"] : <any>null;
            this.fileName = _data["fileName"] !== undefined ? _data["fileName"] : <any>null;
        }
    }

    static fromJS(data: any): DTOConversationImage {
        data = typeof data === 'object' ? data : {};
        let result = new DTOConversationImage();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["conversationImageId"] = this.conversationImageId !== undefined ? this.conversationImageId : <any>null;
        data["name"] = this.name !== undefined ? this.name : <any>null;
        data["fileName"] = this.fileName !== undefined ? this.fileName : <any>null;
        return data; 
    }

    clone(): DTOConversationImage {
        const json = this.toJSON();
        let result = new DTOConversationImage();
        result.init(json);
        return result;
    }
}

export interface IDTOConversationImage {
    conversationImageId: number;
    name?: string | null;
    fileName?: string | null;
}

export class UserConversationsResponseModel extends ResponseBaseModel implements IUserConversationsResponseModel {
    conversations?: DTOConversation[] | null;

    constructor(data?: IUserConversationsResponseModel) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["conversations"])) {
                this.conversations = [] as any;
                for (let item of _data["conversations"])
                    this.conversations!.push(DTOConversation.fromJS(item));
            }
        }
    }

    static fromJS(data: any): UserConversationsResponseModel {
        data = typeof data === 'object' ? data : {};
        let result = new UserConversationsResponseModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.conversations)) {
            data["conversations"] = [];
            for (let item of this.conversations)
                data["conversations"].push(item.toJSON());
        }
        super.toJSON(data);
        return data; 
    }

    clone(): UserConversationsResponseModel {
        const json = this.toJSON();
        let result = new UserConversationsResponseModel();
        result.init(json);
        return result;
    }
}

export interface IUserConversationsResponseModel extends IResponseBaseModel {
    conversations?: DTOConversation[] | null;
}

export class UserConversationsRequestModel implements IUserConversationsRequestModel {

    constructor(data?: IUserConversationsRequestModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
    }

    static fromJS(data: any): UserConversationsRequestModel {
        data = typeof data === 'object' ? data : {};
        let result = new UserConversationsRequestModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        return data; 
    }

    clone(): UserConversationsRequestModel {
        const json = this.toJSON();
        let result = new UserConversationsRequestModel();
        result.init(json);
        return result;
    }
}

export interface IUserConversationsRequestModel {
}

export class MessageSubmitResponseModel extends ResponseBaseModel implements IMessageSubmitResponseModel {
    conversationKey?: string | null;

    constructor(data?: IMessageSubmitResponseModel) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.conversationKey = _data["conversationKey"] !== undefined ? _data["conversationKey"] : <any>null;
        }
    }

    static fromJS(data: any): MessageSubmitResponseModel {
        data = typeof data === 'object' ? data : {};
        let result = new MessageSubmitResponseModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["conversationKey"] = this.conversationKey !== undefined ? this.conversationKey : <any>null;
        super.toJSON(data);
        return data; 
    }

    clone(): MessageSubmitResponseModel {
        const json = this.toJSON();
        let result = new MessageSubmitResponseModel();
        result.init(json);
        return result;
    }
}

export interface IMessageSubmitResponseModel extends IResponseBaseModel {
    conversationKey?: string | null;
}

export class BaseMessageSubmitRequestModel implements IBaseMessageSubmitRequestModel {
    images?: DTOImage[] | null;
    content?: string | null;

    constructor(data?: IBaseMessageSubmitRequestModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["images"])) {
                this.images = [] as any;
                for (let item of _data["images"])
                    this.images!.push(DTOImage.fromJS(item));
            }
            this.content = _data["content"] !== undefined ? _data["content"] : <any>null;
        }
    }

    static fromJS(data: any): BaseMessageSubmitRequestModel {
        data = typeof data === 'object' ? data : {};
        let result = new BaseMessageSubmitRequestModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.images)) {
            data["images"] = [];
            for (let item of this.images)
                data["images"].push(item.toJSON());
        }
        data["content"] = this.content !== undefined ? this.content : <any>null;
        return data; 
    }

    clone(): BaseMessageSubmitRequestModel {
        const json = this.toJSON();
        let result = new BaseMessageSubmitRequestModel();
        result.init(json);
        return result;
    }
}

export interface IBaseMessageSubmitRequestModel {
    images?: DTOImage[] | null;
    content?: string | null;
}

export class ConversationMessageSubmitRequestModel extends BaseMessageSubmitRequestModel implements IConversationMessageSubmitRequestModel {
    conversationId!: number;
    senderId!: number;

    constructor(data?: IConversationMessageSubmitRequestModel) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.conversationId = _data["conversationId"] !== undefined ? _data["conversationId"] : <any>null;
            this.senderId = _data["senderId"] !== undefined ? _data["senderId"] : <any>null;
        }
    }

    static fromJS(data: any): ConversationMessageSubmitRequestModel {
        data = typeof data === 'object' ? data : {};
        let result = new ConversationMessageSubmitRequestModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["conversationId"] = this.conversationId !== undefined ? this.conversationId : <any>null;
        data["senderId"] = this.senderId !== undefined ? this.senderId : <any>null;
        super.toJSON(data);
        return data; 
    }

    clone(): ConversationMessageSubmitRequestModel {
        const json = this.toJSON();
        let result = new ConversationMessageSubmitRequestModel();
        result.init(json);
        return result;
    }
}

export interface IConversationMessageSubmitRequestModel extends IBaseMessageSubmitRequestModel {
    conversationId: number;
    senderId: number;
}

export class DTOImage extends DTOBaseModel implements IDTOImage {
    fileName?: string | null;
    orgFileName?: string | null;

    constructor(data?: IDTOImage) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.fileName = _data["fileName"] !== undefined ? _data["fileName"] : <any>null;
            this.orgFileName = _data["orgFileName"] !== undefined ? _data["orgFileName"] : <any>null;
        }
    }

    static fromJS(data: any): DTOImage {
        data = typeof data === 'object' ? data : {};
        let result = new DTOImage();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["fileName"] = this.fileName !== undefined ? this.fileName : <any>null;
        data["orgFileName"] = this.orgFileName !== undefined ? this.orgFileName : <any>null;
        super.toJSON(data);
        return data; 
    }

    clone(): DTOImage {
        const json = this.toJSON();
        let result = new DTOImage();
        result.init(json);
        return result;
    }
}

export interface IDTOImage extends IDTOBaseModel {
    fileName?: string | null;
    orgFileName?: string | null;
}

export class StartConversationMessageSubmitRequestModel extends BaseMessageSubmitRequestModel implements IStartConversationMessageSubmitRequestModel {
    receiverId!: number;
    senderId!: number;
    senderNick?: string | null;
    advertisementId!: number;

    constructor(data?: IStartConversationMessageSubmitRequestModel) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.receiverId = _data["receiverId"] !== undefined ? _data["receiverId"] : <any>null;
            this.senderId = _data["senderId"] !== undefined ? _data["senderId"] : <any>null;
            this.senderNick = _data["senderNick"] !== undefined ? _data["senderNick"] : <any>null;
            this.advertisementId = _data["advertisementId"] !== undefined ? _data["advertisementId"] : <any>null;
        }
    }

    static fromJS(data: any): StartConversationMessageSubmitRequestModel {
        data = typeof data === 'object' ? data : {};
        let result = new StartConversationMessageSubmitRequestModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["receiverId"] = this.receiverId !== undefined ? this.receiverId : <any>null;
        data["senderId"] = this.senderId !== undefined ? this.senderId : <any>null;
        data["senderNick"] = this.senderNick !== undefined ? this.senderNick : <any>null;
        data["advertisementId"] = this.advertisementId !== undefined ? this.advertisementId : <any>null;
        super.toJSON(data);
        return data; 
    }

    clone(): StartConversationMessageSubmitRequestModel {
        const json = this.toJSON();
        let result = new StartConversationMessageSubmitRequestModel();
        result.init(json);
        return result;
    }
}

export interface IStartConversationMessageSubmitRequestModel extends IBaseMessageSubmitRequestModel {
    receiverId: number;
    senderId: number;
    senderNick?: string | null;
    advertisementId: number;
}

export class EmojiResponseModel extends ResponseBaseModel implements IEmojiResponseModel {
    emojis?: DTOEmoji[] | null;

    constructor(data?: IEmojiResponseModel) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["emojis"])) {
                this.emojis = [] as any;
                for (let item of _data["emojis"])
                    this.emojis!.push(DTOEmoji.fromJS(item));
            }
        }
    }

    static fromJS(data: any): EmojiResponseModel {
        data = typeof data === 'object' ? data : {};
        let result = new EmojiResponseModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.emojis)) {
            data["emojis"] = [];
            for (let item of this.emojis)
                data["emojis"].push(item.toJSON());
        }
        super.toJSON(data);
        return data; 
    }

    clone(): EmojiResponseModel {
        const json = this.toJSON();
        let result = new EmojiResponseModel();
        result.init(json);
        return result;
    }
}

export interface IEmojiResponseModel extends IResponseBaseModel {
    emojis?: DTOEmoji[] | null;
}

export class DTOEmoji implements IDTOEmoji {
    emojiId!: number;
    code?: string | null;
    title?: string | null;
    category?: string | null;

    constructor(data?: IDTOEmoji) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.emojiId = _data["emojiId"] !== undefined ? _data["emojiId"] : <any>null;
            this.code = _data["code"] !== undefined ? _data["code"] : <any>null;
            this.title = _data["title"] !== undefined ? _data["title"] : <any>null;
            this.category = _data["category"] !== undefined ? _data["category"] : <any>null;
        }
    }

    static fromJS(data: any): DTOEmoji {
        data = typeof data === 'object' ? data : {};
        let result = new DTOEmoji();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["emojiId"] = this.emojiId !== undefined ? this.emojiId : <any>null;
        data["code"] = this.code !== undefined ? this.code : <any>null;
        data["title"] = this.title !== undefined ? this.title : <any>null;
        data["category"] = this.category !== undefined ? this.category : <any>null;
        return data; 
    }

    clone(): DTOEmoji {
        const json = this.toJSON();
        let result = new DTOEmoji();
        result.init(json);
        return result;
    }
}

export interface IDTOEmoji {
    emojiId: number;
    code?: string | null;
    title?: string | null;
    category?: string | null;
}

export class BaseModel implements IBaseModel {
    createdAt!: moment.Moment;
    updatedAt!: moment.Moment;
    createdById!: number;
    updatedById!: number;

    constructor(data?: IBaseModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.createdAt = _data["createdAt"] ? moment(_data["createdAt"].toString()) : <any>null;
            this.updatedAt = _data["updatedAt"] ? moment(_data["updatedAt"].toString()) : <any>null;
            this.createdById = _data["createdById"] !== undefined ? _data["createdById"] : <any>null;
            this.updatedById = _data["updatedById"] !== undefined ? _data["updatedById"] : <any>null;
        }
    }

    static fromJS(data: any): BaseModel {
        data = typeof data === 'object' ? data : {};
        let result = new BaseModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["createdAt"] = this.createdAt ? this.createdAt.toISOString() : <any>null;
        data["updatedAt"] = this.updatedAt ? this.updatedAt.toISOString() : <any>null;
        data["createdById"] = this.createdById !== undefined ? this.createdById : <any>null;
        data["updatedById"] = this.updatedById !== undefined ? this.updatedById : <any>null;
        return data; 
    }

    clone(): BaseModel {
        const json = this.toJSON();
        let result = new BaseModel();
        result.init(json);
        return result;
    }
}

export interface IBaseModel {
    createdAt: moment.Moment;
    updatedAt: moment.Moment;
    createdById: number;
    updatedById: number;
}

export class SubRegion extends BaseModel implements ISubRegion {
    subRegionId!: number;
    name!: string;
    zip?: string | null;
    latitude!: number;
    longitude!: number;
    isActive!: boolean;
    regionId!: number;
    demoQuantityRatio!: number;
    population!: number;
    region?: Region | null;
    advertisements?: Advertisement[] | null;

    constructor(data?: ISubRegion) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.subRegionId = _data["subRegionId"] !== undefined ? _data["subRegionId"] : <any>null;
            this.name = _data["name"] !== undefined ? _data["name"] : <any>null;
            this.zip = _data["zip"] !== undefined ? _data["zip"] : <any>null;
            this.latitude = _data["latitude"] !== undefined ? _data["latitude"] : <any>null;
            this.longitude = _data["longitude"] !== undefined ? _data["longitude"] : <any>null;
            this.isActive = _data["isActive"] !== undefined ? _data["isActive"] : <any>null;
            this.regionId = _data["regionId"] !== undefined ? _data["regionId"] : <any>null;
            this.demoQuantityRatio = _data["demoQuantityRatio"] !== undefined ? _data["demoQuantityRatio"] : <any>null;
            this.population = _data["population"] !== undefined ? _data["population"] : <any>null;
            this.region = _data["region"] ? Region.fromJS(_data["region"]) : <any>null;
            if (Array.isArray(_data["advertisements"])) {
                this.advertisements = [] as any;
                for (let item of _data["advertisements"])
                    this.advertisements!.push(Advertisement.fromJS(item));
            }
        }
    }

    static fromJS(data: any): SubRegion {
        data = typeof data === 'object' ? data : {};
        let result = new SubRegion();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["subRegionId"] = this.subRegionId !== undefined ? this.subRegionId : <any>null;
        data["name"] = this.name !== undefined ? this.name : <any>null;
        data["zip"] = this.zip !== undefined ? this.zip : <any>null;
        data["latitude"] = this.latitude !== undefined ? this.latitude : <any>null;
        data["longitude"] = this.longitude !== undefined ? this.longitude : <any>null;
        data["isActive"] = this.isActive !== undefined ? this.isActive : <any>null;
        data["regionId"] = this.regionId !== undefined ? this.regionId : <any>null;
        data["demoQuantityRatio"] = this.demoQuantityRatio !== undefined ? this.demoQuantityRatio : <any>null;
        data["population"] = this.population !== undefined ? this.population : <any>null;
        data["region"] = this.region ? this.region.toJSON() : <any>null;
        if (Array.isArray(this.advertisements)) {
            data["advertisements"] = [];
            for (let item of this.advertisements)
                data["advertisements"].push(item.toJSON());
        }
        super.toJSON(data);
        return data; 
    }

    clone(): SubRegion {
        const json = this.toJSON();
        let result = new SubRegion();
        result.init(json);
        return result;
    }
}

export interface ISubRegion extends IBaseModel {
    subRegionId: number;
    name: string;
    zip?: string | null;
    latitude: number;
    longitude: number;
    isActive: boolean;
    regionId: number;
    demoQuantityRatio: number;
    population: number;
    region?: Region | null;
    advertisements?: Advertisement[] | null;
}

export class Region extends BaseModel implements IRegion {
    regionId!: number;
    shortName!: string;
    name!: string;
    isActive!: boolean;
    subRegions?: SubRegion[] | null;
    advertisements?: Advertisement[] | null;

    constructor(data?: IRegion) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.regionId = _data["regionId"] !== undefined ? _data["regionId"] : <any>null;
            this.shortName = _data["shortName"] !== undefined ? _data["shortName"] : <any>null;
            this.name = _data["name"] !== undefined ? _data["name"] : <any>null;
            this.isActive = _data["isActive"] !== undefined ? _data["isActive"] : <any>null;
            if (Array.isArray(_data["subRegions"])) {
                this.subRegions = [] as any;
                for (let item of _data["subRegions"])
                    this.subRegions!.push(SubRegion.fromJS(item));
            }
            if (Array.isArray(_data["advertisements"])) {
                this.advertisements = [] as any;
                for (let item of _data["advertisements"])
                    this.advertisements!.push(Advertisement.fromJS(item));
            }
        }
    }

    static fromJS(data: any): Region {
        data = typeof data === 'object' ? data : {};
        let result = new Region();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["regionId"] = this.regionId !== undefined ? this.regionId : <any>null;
        data["shortName"] = this.shortName !== undefined ? this.shortName : <any>null;
        data["name"] = this.name !== undefined ? this.name : <any>null;
        data["isActive"] = this.isActive !== undefined ? this.isActive : <any>null;
        if (Array.isArray(this.subRegions)) {
            data["subRegions"] = [];
            for (let item of this.subRegions)
                data["subRegions"].push(item.toJSON());
        }
        if (Array.isArray(this.advertisements)) {
            data["advertisements"] = [];
            for (let item of this.advertisements)
                data["advertisements"].push(item.toJSON());
        }
        super.toJSON(data);
        return data; 
    }

    clone(): Region {
        const json = this.toJSON();
        let result = new Region();
        result.init(json);
        return result;
    }
}

export interface IRegion extends IBaseModel {
    regionId: number;
    shortName: string;
    name: string;
    isActive: boolean;
    subRegions?: SubRegion[] | null;
    advertisements?: Advertisement[] | null;
}

export class Advertisement extends BaseModel implements IAdvertisement {
    advertisementId!: number;
    regionId?: number | null;
    subRegionId?: number | null;
    seen!: boolean;
    seenAdmin!: boolean;
    region?: Region | null;
    subRegion?: SubRegion | null;
    zipCode?: string | null;
    location?: Point | null;
    dateStart!: moment.Moment;
    dateEnd?: moment.Moment | null;
    title!: string;
    content?: string | null;
    published!: boolean;
    casualDating!: boolean;
    advertisementCategoryId!: number;
    nick?: string | null;
    category?: AdvertisementCategory | null;
    images?: AdvertisementImage[] | null;
    conversations?: Conversation[] | null;
    userId!: number;
    isDemo!: boolean;
    isPremium!: boolean;
    user?: User | null;
    manageId?: string | null;
    moderated!: boolean;
    moderatedAt?: moment.Moment | null;
    moderatedBy?: number | null;
    moderateText?: string | null;
    age?: string | null;
    settings?: AdvertisementSetting | null;

    constructor(data?: IAdvertisement) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.advertisementId = _data["advertisementId"] !== undefined ? _data["advertisementId"] : <any>null;
            this.regionId = _data["regionId"] !== undefined ? _data["regionId"] : <any>null;
            this.subRegionId = _data["subRegionId"] !== undefined ? _data["subRegionId"] : <any>null;
            this.seen = _data["seen"] !== undefined ? _data["seen"] : <any>null;
            this.seenAdmin = _data["seenAdmin"] !== undefined ? _data["seenAdmin"] : <any>null;
            this.region = _data["region"] ? Region.fromJS(_data["region"]) : <any>null;
            this.subRegion = _data["subRegion"] ? SubRegion.fromJS(_data["subRegion"]) : <any>null;
            this.zipCode = _data["zipCode"] !== undefined ? _data["zipCode"] : <any>null;
            this.location = _data["location"] ? Point.fromJS(_data["location"]) : <any>null;
            this.dateStart = _data["dateStart"] ? moment(_data["dateStart"].toString()) : <any>null;
            this.dateEnd = _data["dateEnd"] ? moment(_data["dateEnd"].toString()) : <any>null;
            this.title = _data["title"] !== undefined ? _data["title"] : <any>null;
            this.content = _data["content"] !== undefined ? _data["content"] : <any>null;
            this.published = _data["published"] !== undefined ? _data["published"] : <any>null;
            this.casualDating = _data["casualDating"] !== undefined ? _data["casualDating"] : <any>null;
            this.advertisementCategoryId = _data["advertisementCategoryId"] !== undefined ? _data["advertisementCategoryId"] : <any>null;
            this.nick = _data["nick"] !== undefined ? _data["nick"] : <any>null;
            this.category = _data["category"] ? AdvertisementCategory.fromJS(_data["category"]) : <any>null;
            if (Array.isArray(_data["images"])) {
                this.images = [] as any;
                for (let item of _data["images"])
                    this.images!.push(AdvertisementImage.fromJS(item));
            }
            if (Array.isArray(_data["conversations"])) {
                this.conversations = [] as any;
                for (let item of _data["conversations"])
                    this.conversations!.push(Conversation.fromJS(item));
            }
            this.userId = _data["userId"] !== undefined ? _data["userId"] : <any>null;
            this.isDemo = _data["isDemo"] !== undefined ? _data["isDemo"] : <any>null;
            this.isPremium = _data["isPremium"] !== undefined ? _data["isPremium"] : <any>null;
            this.user = _data["user"] ? User.fromJS(_data["user"]) : <any>null;
            this.manageId = _data["manageId"] !== undefined ? _data["manageId"] : <any>null;
            this.moderated = _data["moderated"] !== undefined ? _data["moderated"] : <any>null;
            this.moderatedAt = _data["moderatedAt"] ? moment(_data["moderatedAt"].toString()) : <any>null;
            this.moderatedBy = _data["moderatedBy"] !== undefined ? _data["moderatedBy"] : <any>null;
            this.moderateText = _data["moderateText"] !== undefined ? _data["moderateText"] : <any>null;
            this.age = _data["age"] !== undefined ? _data["age"] : <any>null;
            this.settings = _data["settings"] ? AdvertisementSetting.fromJS(_data["settings"]) : <any>null;
        }
    }

    static fromJS(data: any): Advertisement {
        data = typeof data === 'object' ? data : {};
        let result = new Advertisement();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["advertisementId"] = this.advertisementId !== undefined ? this.advertisementId : <any>null;
        data["regionId"] = this.regionId !== undefined ? this.regionId : <any>null;
        data["subRegionId"] = this.subRegionId !== undefined ? this.subRegionId : <any>null;
        data["seen"] = this.seen !== undefined ? this.seen : <any>null;
        data["seenAdmin"] = this.seenAdmin !== undefined ? this.seenAdmin : <any>null;
        data["region"] = this.region ? this.region.toJSON() : <any>null;
        data["subRegion"] = this.subRegion ? this.subRegion.toJSON() : <any>null;
        data["zipCode"] = this.zipCode !== undefined ? this.zipCode : <any>null;
        data["location"] = this.location ? this.location.toJSON() : <any>null;
        data["dateStart"] = this.dateStart ? this.dateStart.toISOString() : <any>null;
        data["dateEnd"] = this.dateEnd ? this.dateEnd.toISOString() : <any>null;
        data["title"] = this.title !== undefined ? this.title : <any>null;
        data["content"] = this.content !== undefined ? this.content : <any>null;
        data["published"] = this.published !== undefined ? this.published : <any>null;
        data["casualDating"] = this.casualDating !== undefined ? this.casualDating : <any>null;
        data["advertisementCategoryId"] = this.advertisementCategoryId !== undefined ? this.advertisementCategoryId : <any>null;
        data["nick"] = this.nick !== undefined ? this.nick : <any>null;
        data["category"] = this.category ? this.category.toJSON() : <any>null;
        if (Array.isArray(this.images)) {
            data["images"] = [];
            for (let item of this.images)
                data["images"].push(item.toJSON());
        }
        if (Array.isArray(this.conversations)) {
            data["conversations"] = [];
            for (let item of this.conversations)
                data["conversations"].push(item.toJSON());
        }
        data["userId"] = this.userId !== undefined ? this.userId : <any>null;
        data["isDemo"] = this.isDemo !== undefined ? this.isDemo : <any>null;
        data["isPremium"] = this.isPremium !== undefined ? this.isPremium : <any>null;
        data["user"] = this.user ? this.user.toJSON() : <any>null;
        data["manageId"] = this.manageId !== undefined ? this.manageId : <any>null;
        data["moderated"] = this.moderated !== undefined ? this.moderated : <any>null;
        data["moderatedAt"] = this.moderatedAt ? this.moderatedAt.toISOString() : <any>null;
        data["moderatedBy"] = this.moderatedBy !== undefined ? this.moderatedBy : <any>null;
        data["moderateText"] = this.moderateText !== undefined ? this.moderateText : <any>null;
        data["age"] = this.age !== undefined ? this.age : <any>null;
        data["settings"] = this.settings ? this.settings.toJSON() : <any>null;
        super.toJSON(data);
        return data; 
    }

    clone(): Advertisement {
        const json = this.toJSON();
        let result = new Advertisement();
        result.init(json);
        return result;
    }
}

export interface IAdvertisement extends IBaseModel {
    advertisementId: number;
    regionId?: number | null;
    subRegionId?: number | null;
    seen: boolean;
    seenAdmin: boolean;
    region?: Region | null;
    subRegion?: SubRegion | null;
    zipCode?: string | null;
    location?: Point | null;
    dateStart: moment.Moment;
    dateEnd?: moment.Moment | null;
    title: string;
    content?: string | null;
    published: boolean;
    casualDating: boolean;
    advertisementCategoryId: number;
    nick?: string | null;
    category?: AdvertisementCategory | null;
    images?: AdvertisementImage[] | null;
    conversations?: Conversation[] | null;
    userId: number;
    isDemo: boolean;
    isPremium: boolean;
    user?: User | null;
    manageId?: string | null;
    moderated: boolean;
    moderatedAt?: moment.Moment | null;
    moderatedBy?: number | null;
    moderateText?: string | null;
    age?: string | null;
    settings?: AdvertisementSetting | null;
}

export abstract class Geometry implements IGeometry {
    factory?: GeometryFactory | null;
    userData?: any | null;
    srid!: number;
    precisionModel?: PrecisionModel | null;
    numGeometries!: number;
    isSimple!: boolean;
    isValid!: boolean;
    area!: number;
    length!: number;
    centroid?: Point | null;
    interiorPoint?: Point | null;
    pointOnSurface?: Point | null;
    envelope?: Geometry | null;
    envelopeInternal?: Envelope | null;
    isRectangle!: boolean;

    constructor(data?: IGeometry) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.factory = _data["factory"] ? GeometryFactory.fromJS(_data["factory"]) : <any>null;
            this.userData = _data["userData"] !== undefined ? _data["userData"] : <any>null;
            this.srid = _data["srid"] !== undefined ? _data["srid"] : <any>null;
            this.precisionModel = _data["precisionModel"] ? PrecisionModel.fromJS(_data["precisionModel"]) : <any>null;
            this.numGeometries = _data["numGeometries"] !== undefined ? _data["numGeometries"] : <any>null;
            this.isSimple = _data["isSimple"] !== undefined ? _data["isSimple"] : <any>null;
            this.isValid = _data["isValid"] !== undefined ? _data["isValid"] : <any>null;
            this.area = _data["area"] !== undefined ? _data["area"] : <any>null;
            this.length = _data["length"] !== undefined ? _data["length"] : <any>null;
            this.centroid = _data["centroid"] ? Point.fromJS(_data["centroid"]) : <any>null;
            this.interiorPoint = _data["interiorPoint"] ? Point.fromJS(_data["interiorPoint"]) : <any>null;
            this.pointOnSurface = _data["pointOnSurface"] ? Point.fromJS(_data["pointOnSurface"]) : <any>null;
            this.envelope = _data["envelope"] ? Geometry.fromJS(_data["envelope"]) : <any>null;
            this.envelopeInternal = _data["envelopeInternal"] ? Envelope.fromJS(_data["envelopeInternal"]) : <any>null;
            this.isRectangle = _data["isRectangle"] !== undefined ? _data["isRectangle"] : <any>null;
        }
    }

    static fromJS(data: any): Geometry {
        data = typeof data === 'object' ? data : {};
        throw new Error("The abstract class 'Geometry' cannot be instantiated.");
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["factory"] = this.factory ? this.factory.toJSON() : <any>null;
        data["userData"] = this.userData !== undefined ? this.userData : <any>null;
        data["srid"] = this.srid !== undefined ? this.srid : <any>null;
        data["precisionModel"] = this.precisionModel ? this.precisionModel.toJSON() : <any>null;
        data["numGeometries"] = this.numGeometries !== undefined ? this.numGeometries : <any>null;
        data["isSimple"] = this.isSimple !== undefined ? this.isSimple : <any>null;
        data["isValid"] = this.isValid !== undefined ? this.isValid : <any>null;
        data["area"] = this.area !== undefined ? this.area : <any>null;
        data["length"] = this.length !== undefined ? this.length : <any>null;
        data["centroid"] = this.centroid ? this.centroid.toJSON() : <any>null;
        data["interiorPoint"] = this.interiorPoint ? this.interiorPoint.toJSON() : <any>null;
        data["pointOnSurface"] = this.pointOnSurface ? this.pointOnSurface.toJSON() : <any>null;
        data["envelope"] = this.envelope ? this.envelope.toJSON() : <any>null;
        data["envelopeInternal"] = this.envelopeInternal ? this.envelopeInternal.toJSON() : <any>null;
        data["isRectangle"] = this.isRectangle !== undefined ? this.isRectangle : <any>null;
        return data; 
    }

    clone(): Geometry {
        throw new Error("The abstract class 'Geometry' cannot be instantiated.");
    }
}

export interface IGeometry {
    factory?: GeometryFactory | null;
    userData?: any | null;
    srid: number;
    precisionModel?: PrecisionModel | null;
    numGeometries: number;
    isSimple: boolean;
    isValid: boolean;
    area: number;
    length: number;
    centroid?: Point | null;
    interiorPoint?: Point | null;
    pointOnSurface?: Point | null;
    envelope?: Geometry | null;
    envelopeInternal?: Envelope | null;
    isRectangle: boolean;
}

export class Point extends Geometry implements IPoint {
    coordinateSequence?: CoordinateSequence | null;
    coordinates?: Coordinate[] | null;
    numPoints!: number;
    isEmpty!: boolean;
    dimension!: Dimension;
    boundaryDimension!: Dimension;
    x!: number;
    y!: number;
    coordinate?: Coordinate | null;
    geometryType?: string | null;
    ogcGeometryType!: OgcGeometryType;
    boundary?: Geometry | null;
    z!: number;
    m!: number;

    constructor(data?: IPoint) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.coordinateSequence = _data["coordinateSequence"] ? CoordinateSequence.fromJS(_data["coordinateSequence"]) : <any>null;
            if (Array.isArray(_data["coordinates"])) {
                this.coordinates = [] as any;
                for (let item of _data["coordinates"])
                    this.coordinates!.push(Coordinate.fromJS(item));
            }
            this.numPoints = _data["numPoints"] !== undefined ? _data["numPoints"] : <any>null;
            this.isEmpty = _data["isEmpty"] !== undefined ? _data["isEmpty"] : <any>null;
            this.dimension = _data["dimension"] !== undefined ? _data["dimension"] : <any>null;
            this.boundaryDimension = _data["boundaryDimension"] !== undefined ? _data["boundaryDimension"] : <any>null;
            this.x = _data["x"] !== undefined ? _data["x"] : <any>null;
            this.y = _data["y"] !== undefined ? _data["y"] : <any>null;
            this.coordinate = _data["coordinate"] ? Coordinate.fromJS(_data["coordinate"]) : <any>null;
            this.geometryType = _data["geometryType"] !== undefined ? _data["geometryType"] : <any>null;
            this.ogcGeometryType = _data["ogcGeometryType"] !== undefined ? _data["ogcGeometryType"] : <any>null;
            this.boundary = _data["boundary"] ? Geometry.fromJS(_data["boundary"]) : <any>null;
            this.z = _data["z"] !== undefined ? _data["z"] : <any>null;
            this.m = _data["m"] !== undefined ? _data["m"] : <any>null;
        }
    }

    static fromJS(data: any): Point {
        data = typeof data === 'object' ? data : {};
        let result = new Point();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["coordinateSequence"] = this.coordinateSequence ? this.coordinateSequence.toJSON() : <any>null;
        if (Array.isArray(this.coordinates)) {
            data["coordinates"] = [];
            for (let item of this.coordinates)
                data["coordinates"].push(item.toJSON());
        }
        data["numPoints"] = this.numPoints !== undefined ? this.numPoints : <any>null;
        data["isEmpty"] = this.isEmpty !== undefined ? this.isEmpty : <any>null;
        data["dimension"] = this.dimension !== undefined ? this.dimension : <any>null;
        data["boundaryDimension"] = this.boundaryDimension !== undefined ? this.boundaryDimension : <any>null;
        data["x"] = this.x !== undefined ? this.x : <any>null;
        data["y"] = this.y !== undefined ? this.y : <any>null;
        data["coordinate"] = this.coordinate ? this.coordinate.toJSON() : <any>null;
        data["geometryType"] = this.geometryType !== undefined ? this.geometryType : <any>null;
        data["ogcGeometryType"] = this.ogcGeometryType !== undefined ? this.ogcGeometryType : <any>null;
        data["boundary"] = this.boundary ? this.boundary.toJSON() : <any>null;
        data["z"] = this.z !== undefined ? this.z : <any>null;
        data["m"] = this.m !== undefined ? this.m : <any>null;
        super.toJSON(data);
        return data; 
    }

    clone(): Point {
        const json = this.toJSON();
        let result = new Point();
        result.init(json);
        return result;
    }
}

export interface IPoint extends IGeometry {
    coordinateSequence?: CoordinateSequence | null;
    coordinates?: Coordinate[] | null;
    numPoints: number;
    isEmpty: boolean;
    dimension: Dimension;
    boundaryDimension: Dimension;
    x: number;
    y: number;
    coordinate?: Coordinate | null;
    geometryType?: string | null;
    ogcGeometryType: OgcGeometryType;
    boundary?: Geometry | null;
    z: number;
    m: number;
}

export abstract class CoordinateSequence implements ICoordinateSequence {
    dimension!: number;
    measures!: number;
    spatial!: number;
    ordinates!: Ordinates;
    hasZ!: boolean;
    hasM!: boolean;
    zOrdinateIndex!: number;
    mOrdinateIndex!: number;
    count!: number;

    constructor(data?: ICoordinateSequence) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.dimension = _data["dimension"] !== undefined ? _data["dimension"] : <any>null;
            this.measures = _data["measures"] !== undefined ? _data["measures"] : <any>null;
            this.spatial = _data["spatial"] !== undefined ? _data["spatial"] : <any>null;
            this.ordinates = _data["ordinates"] !== undefined ? _data["ordinates"] : <any>null;
            this.hasZ = _data["hasZ"] !== undefined ? _data["hasZ"] : <any>null;
            this.hasM = _data["hasM"] !== undefined ? _data["hasM"] : <any>null;
            this.zOrdinateIndex = _data["zOrdinateIndex"] !== undefined ? _data["zOrdinateIndex"] : <any>null;
            this.mOrdinateIndex = _data["mOrdinateIndex"] !== undefined ? _data["mOrdinateIndex"] : <any>null;
            this.count = _data["count"] !== undefined ? _data["count"] : <any>null;
        }
    }

    static fromJS(data: any): CoordinateSequence {
        data = typeof data === 'object' ? data : {};
        throw new Error("The abstract class 'CoordinateSequence' cannot be instantiated.");
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["dimension"] = this.dimension !== undefined ? this.dimension : <any>null;
        data["measures"] = this.measures !== undefined ? this.measures : <any>null;
        data["spatial"] = this.spatial !== undefined ? this.spatial : <any>null;
        data["ordinates"] = this.ordinates !== undefined ? this.ordinates : <any>null;
        data["hasZ"] = this.hasZ !== undefined ? this.hasZ : <any>null;
        data["hasM"] = this.hasM !== undefined ? this.hasM : <any>null;
        data["zOrdinateIndex"] = this.zOrdinateIndex !== undefined ? this.zOrdinateIndex : <any>null;
        data["mOrdinateIndex"] = this.mOrdinateIndex !== undefined ? this.mOrdinateIndex : <any>null;
        data["count"] = this.count !== undefined ? this.count : <any>null;
        return data; 
    }

    clone(): CoordinateSequence {
        throw new Error("The abstract class 'CoordinateSequence' cannot be instantiated.");
    }
}

export interface ICoordinateSequence {
    dimension: number;
    measures: number;
    spatial: number;
    ordinates: Ordinates;
    hasZ: boolean;
    hasM: boolean;
    zOrdinateIndex: number;
    mOrdinateIndex: number;
    count: number;
}

export enum Ordinates {
    None = 0,
    X = 1,
    Spatial1 = 1,
    Y = 2,
    Spatial2 = 2,
    XY = 3,
    Spatial3 = 4,
    Z = 4,
    XYZ = 7,
    Spatial4 = 8,
    Spatial5 = 16,
    Spatial6 = 32,
    Spatial7 = 64,
    Spatial8 = 128,
    Spatial9 = 256,
    Spatial10 = 512,
    Spatial11 = 1024,
    Spatial12 = 2048,
    Spatial13 = 4096,
    Spatial14 = 8192,
    Spatial15 = 16384,
    Spatial16 = 32768,
    AllSpatialOrdinates = 65535,
    Measure1 = 65536,
    M = 65536,
    XYM = 65539,
    XYZM = 65543,
    Measure2 = 131072,
    Measure3 = 262144,
    Measure4 = 524288,
    Measure5 = 1048576,
    Measure6 = 2097152,
    Measure7 = 4194304,
    Measure8 = 8388608,
    Measure9 = 16777216,
    Measure10 = 33554432,
    Measure11 = 67108864,
    Measure12 = 134217728,
    Measure13 = 268435456,
    Measure14 = 536870912,
    Measure15 = 1073741824,
    Measure16 = -2147483648,
    AllMeasureOrdinates = -65536,
    AllOrdinates = -1,
}

export class Coordinate implements ICoordinate {
    x!: number;
    y!: number;
    z!: number;
    m!: number;
    coordinateValue?: Coordinate | null;

    constructor(data?: ICoordinate) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.x = _data["x"] !== undefined ? _data["x"] : <any>null;
            this.y = _data["y"] !== undefined ? _data["y"] : <any>null;
            this.z = _data["z"] !== undefined ? _data["z"] : <any>null;
            this.m = _data["m"] !== undefined ? _data["m"] : <any>null;
            this.coordinateValue = _data["coordinateValue"] ? Coordinate.fromJS(_data["coordinateValue"]) : <any>null;
        }
    }

    static fromJS(data: any): Coordinate {
        data = typeof data === 'object' ? data : {};
        let result = new Coordinate();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["x"] = this.x !== undefined ? this.x : <any>null;
        data["y"] = this.y !== undefined ? this.y : <any>null;
        data["z"] = this.z !== undefined ? this.z : <any>null;
        data["m"] = this.m !== undefined ? this.m : <any>null;
        data["coordinateValue"] = this.coordinateValue ? this.coordinateValue.toJSON() : <any>null;
        return data; 
    }

    clone(): Coordinate {
        const json = this.toJSON();
        let result = new Coordinate();
        result.init(json);
        return result;
    }
}

export interface ICoordinate {
    x: number;
    y: number;
    z: number;
    m: number;
    coordinateValue?: Coordinate | null;
}

export enum Dimension {
    Point = 0,
    Curve = 1,
    Surface = 2,
    Dontcare = -3,
    True = -2,
    False = -1,
}

export enum OgcGeometryType {
    Point = 1,
    LineString = 2,
    Polygon = 3,
    MultiPoint = 4,
    MultiLineString = 5,
    MultiPolygon = 6,
    GeometryCollection = 7,
    CircularString = 8,
    CompoundCurve = 9,
    CurvePolygon = 10,
    MultiCurve = 11,
    MultiSurface = 12,
    Curve = 13,
    Surface = 14,
    PolyhedralSurface = 15,
    TIN = 16,
}

export class GeometryFactory implements IGeometryFactory {
    precisionModel?: PrecisionModel | null;
    coordinateSequenceFactory?: CoordinateSequenceFactory | null;
    srid!: number;

    constructor(data?: IGeometryFactory) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.precisionModel = _data["precisionModel"] ? PrecisionModel.fromJS(_data["precisionModel"]) : <any>null;
            this.coordinateSequenceFactory = _data["coordinateSequenceFactory"] ? CoordinateSequenceFactory.fromJS(_data["coordinateSequenceFactory"]) : <any>null;
            this.srid = _data["srid"] !== undefined ? _data["srid"] : <any>null;
        }
    }

    static fromJS(data: any): GeometryFactory {
        data = typeof data === 'object' ? data : {};
        let result = new GeometryFactory();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["precisionModel"] = this.precisionModel ? this.precisionModel.toJSON() : <any>null;
        data["coordinateSequenceFactory"] = this.coordinateSequenceFactory ? this.coordinateSequenceFactory.toJSON() : <any>null;
        data["srid"] = this.srid !== undefined ? this.srid : <any>null;
        return data; 
    }

    clone(): GeometryFactory {
        const json = this.toJSON();
        let result = new GeometryFactory();
        result.init(json);
        return result;
    }
}

export interface IGeometryFactory {
    precisionModel?: PrecisionModel | null;
    coordinateSequenceFactory?: CoordinateSequenceFactory | null;
    srid: number;
}

export class PrecisionModel implements IPrecisionModel {
    isFloating!: boolean;
    maximumSignificantDigits!: number;
    scale!: number;
    precisionModelType!: PrecisionModels;

    constructor(data?: IPrecisionModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.isFloating = _data["isFloating"] !== undefined ? _data["isFloating"] : <any>null;
            this.maximumSignificantDigits = _data["maximumSignificantDigits"] !== undefined ? _data["maximumSignificantDigits"] : <any>null;
            this.scale = _data["scale"] !== undefined ? _data["scale"] : <any>null;
            this.precisionModelType = _data["precisionModelType"] !== undefined ? _data["precisionModelType"] : <any>null;
        }
    }

    static fromJS(data: any): PrecisionModel {
        data = typeof data === 'object' ? data : {};
        let result = new PrecisionModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["isFloating"] = this.isFloating !== undefined ? this.isFloating : <any>null;
        data["maximumSignificantDigits"] = this.maximumSignificantDigits !== undefined ? this.maximumSignificantDigits : <any>null;
        data["scale"] = this.scale !== undefined ? this.scale : <any>null;
        data["precisionModelType"] = this.precisionModelType !== undefined ? this.precisionModelType : <any>null;
        return data; 
    }

    clone(): PrecisionModel {
        const json = this.toJSON();
        let result = new PrecisionModel();
        result.init(json);
        return result;
    }
}

export interface IPrecisionModel {
    isFloating: boolean;
    maximumSignificantDigits: number;
    scale: number;
    precisionModelType: PrecisionModels;
}

export enum PrecisionModels {
    Floating = 0,
    FloatingSingle = 1,
    Fixed = 2,
}

export abstract class CoordinateSequenceFactory implements ICoordinateSequenceFactory {
    ordinates!: Ordinates;

    constructor(data?: ICoordinateSequenceFactory) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.ordinates = _data["ordinates"] !== undefined ? _data["ordinates"] : <any>null;
        }
    }

    static fromJS(data: any): CoordinateSequenceFactory {
        data = typeof data === 'object' ? data : {};
        throw new Error("The abstract class 'CoordinateSequenceFactory' cannot be instantiated.");
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["ordinates"] = this.ordinates !== undefined ? this.ordinates : <any>null;
        return data; 
    }

    clone(): CoordinateSequenceFactory {
        throw new Error("The abstract class 'CoordinateSequenceFactory' cannot be instantiated.");
    }
}

export interface ICoordinateSequenceFactory {
    ordinates: Ordinates;
}

export class Envelope implements IEnvelope {
    isNull!: boolean;
    width!: number;
    height!: number;
    minX!: number;
    maxX!: number;
    minY!: number;
    maxY!: number;
    area!: number;
    minExtent!: number;
    maxExtent!: number;
    centre?: Coordinate | null;

    constructor(data?: IEnvelope) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.isNull = _data["isNull"] !== undefined ? _data["isNull"] : <any>null;
            this.width = _data["width"] !== undefined ? _data["width"] : <any>null;
            this.height = _data["height"] !== undefined ? _data["height"] : <any>null;
            this.minX = _data["minX"] !== undefined ? _data["minX"] : <any>null;
            this.maxX = _data["maxX"] !== undefined ? _data["maxX"] : <any>null;
            this.minY = _data["minY"] !== undefined ? _data["minY"] : <any>null;
            this.maxY = _data["maxY"] !== undefined ? _data["maxY"] : <any>null;
            this.area = _data["area"] !== undefined ? _data["area"] : <any>null;
            this.minExtent = _data["minExtent"] !== undefined ? _data["minExtent"] : <any>null;
            this.maxExtent = _data["maxExtent"] !== undefined ? _data["maxExtent"] : <any>null;
            this.centre = _data["centre"] ? Coordinate.fromJS(_data["centre"]) : <any>null;
        }
    }

    static fromJS(data: any): Envelope {
        data = typeof data === 'object' ? data : {};
        let result = new Envelope();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["isNull"] = this.isNull !== undefined ? this.isNull : <any>null;
        data["width"] = this.width !== undefined ? this.width : <any>null;
        data["height"] = this.height !== undefined ? this.height : <any>null;
        data["minX"] = this.minX !== undefined ? this.minX : <any>null;
        data["maxX"] = this.maxX !== undefined ? this.maxX : <any>null;
        data["minY"] = this.minY !== undefined ? this.minY : <any>null;
        data["maxY"] = this.maxY !== undefined ? this.maxY : <any>null;
        data["area"] = this.area !== undefined ? this.area : <any>null;
        data["minExtent"] = this.minExtent !== undefined ? this.minExtent : <any>null;
        data["maxExtent"] = this.maxExtent !== undefined ? this.maxExtent : <any>null;
        data["centre"] = this.centre ? this.centre.toJSON() : <any>null;
        return data; 
    }

    clone(): Envelope {
        const json = this.toJSON();
        let result = new Envelope();
        result.init(json);
        return result;
    }
}

export interface IEnvelope {
    isNull: boolean;
    width: number;
    height: number;
    minX: number;
    maxX: number;
    minY: number;
    maxY: number;
    area: number;
    minExtent: number;
    maxExtent: number;
    centre?: Coordinate | null;
}

export class AdvertisementCategory extends BaseModel implements IAdvertisementCategory {
    advertisementCategoryId!: number;
    name!: string;
    code?: string | null;
    orderIndex!: number;
    casualDating!: boolean;

    constructor(data?: IAdvertisementCategory) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.advertisementCategoryId = _data["advertisementCategoryId"] !== undefined ? _data["advertisementCategoryId"] : <any>null;
            this.name = _data["name"] !== undefined ? _data["name"] : <any>null;
            this.code = _data["code"] !== undefined ? _data["code"] : <any>null;
            this.orderIndex = _data["orderIndex"] !== undefined ? _data["orderIndex"] : <any>null;
            this.casualDating = _data["casualDating"] !== undefined ? _data["casualDating"] : <any>null;
        }
    }

    static fromJS(data: any): AdvertisementCategory {
        data = typeof data === 'object' ? data : {};
        let result = new AdvertisementCategory();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["advertisementCategoryId"] = this.advertisementCategoryId !== undefined ? this.advertisementCategoryId : <any>null;
        data["name"] = this.name !== undefined ? this.name : <any>null;
        data["code"] = this.code !== undefined ? this.code : <any>null;
        data["orderIndex"] = this.orderIndex !== undefined ? this.orderIndex : <any>null;
        data["casualDating"] = this.casualDating !== undefined ? this.casualDating : <any>null;
        super.toJSON(data);
        return data; 
    }

    clone(): AdvertisementCategory {
        const json = this.toJSON();
        let result = new AdvertisementCategory();
        result.init(json);
        return result;
    }
}

export interface IAdvertisementCategory extends IBaseModel {
    advertisementCategoryId: number;
    name: string;
    code?: string | null;
    orderIndex: number;
    casualDating: boolean;
}

export class AdvertisementImage extends BaseModel implements IAdvertisementImage {
    advertisementImageId!: number;
    advertisementId!: number;
    advertisement?: Advertisement | null;
    name!: string;
    fileName!: string;
    orgFileName?: string | null;
    orderIndex!: number;
    isMain!: boolean;

    constructor(data?: IAdvertisementImage) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.advertisementImageId = _data["advertisementImageId"] !== undefined ? _data["advertisementImageId"] : <any>null;
            this.advertisementId = _data["advertisementId"] !== undefined ? _data["advertisementId"] : <any>null;
            this.advertisement = _data["advertisement"] ? Advertisement.fromJS(_data["advertisement"]) : <any>null;
            this.name = _data["name"] !== undefined ? _data["name"] : <any>null;
            this.fileName = _data["fileName"] !== undefined ? _data["fileName"] : <any>null;
            this.orgFileName = _data["orgFileName"] !== undefined ? _data["orgFileName"] : <any>null;
            this.orderIndex = _data["orderIndex"] !== undefined ? _data["orderIndex"] : <any>null;
            this.isMain = _data["isMain"] !== undefined ? _data["isMain"] : <any>null;
        }
    }

    static fromJS(data: any): AdvertisementImage {
        data = typeof data === 'object' ? data : {};
        let result = new AdvertisementImage();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["advertisementImageId"] = this.advertisementImageId !== undefined ? this.advertisementImageId : <any>null;
        data["advertisementId"] = this.advertisementId !== undefined ? this.advertisementId : <any>null;
        data["advertisement"] = this.advertisement ? this.advertisement.toJSON() : <any>null;
        data["name"] = this.name !== undefined ? this.name : <any>null;
        data["fileName"] = this.fileName !== undefined ? this.fileName : <any>null;
        data["orgFileName"] = this.orgFileName !== undefined ? this.orgFileName : <any>null;
        data["orderIndex"] = this.orderIndex !== undefined ? this.orderIndex : <any>null;
        data["isMain"] = this.isMain !== undefined ? this.isMain : <any>null;
        super.toJSON(data);
        return data; 
    }

    clone(): AdvertisementImage {
        const json = this.toJSON();
        let result = new AdvertisementImage();
        result.init(json);
        return result;
    }
}

export interface IAdvertisementImage extends IBaseModel {
    advertisementImageId: number;
    advertisementId: number;
    advertisement?: Advertisement | null;
    name: string;
    fileName: string;
    orgFileName?: string | null;
    orderIndex: number;
    isMain: boolean;
}

export class Conversation implements IConversation {
    conversationId!: number;
    senderEmail?: string | null;
    senderNick?: string | null;
    receiverNick?: string | null;
    receiverEmail?: string | null;
    conversationKey?: string | null;
    creationDate!: moment.Moment;
    ownerUserId!: number;
    ownerUser?: User | null;
    receiverUserId!: number;
    receiverUser?: User | null;
    advertisementId!: number;
    advertisement?: Advertisement | null;
    messages?: ConversationMessage[] | null;

    constructor(data?: IConversation) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.conversationId = _data["conversationId"] !== undefined ? _data["conversationId"] : <any>null;
            this.senderEmail = _data["senderEmail"] !== undefined ? _data["senderEmail"] : <any>null;
            this.senderNick = _data["senderNick"] !== undefined ? _data["senderNick"] : <any>null;
            this.receiverNick = _data["receiverNick"] !== undefined ? _data["receiverNick"] : <any>null;
            this.receiverEmail = _data["receiverEmail"] !== undefined ? _data["receiverEmail"] : <any>null;
            this.conversationKey = _data["conversationKey"] !== undefined ? _data["conversationKey"] : <any>null;
            this.creationDate = _data["creationDate"] ? moment(_data["creationDate"].toString()) : <any>null;
            this.ownerUserId = _data["ownerUserId"] !== undefined ? _data["ownerUserId"] : <any>null;
            this.ownerUser = _data["ownerUser"] ? User.fromJS(_data["ownerUser"]) : <any>null;
            this.receiverUserId = _data["receiverUserId"] !== undefined ? _data["receiverUserId"] : <any>null;
            this.receiverUser = _data["receiverUser"] ? User.fromJS(_data["receiverUser"]) : <any>null;
            this.advertisementId = _data["advertisementId"] !== undefined ? _data["advertisementId"] : <any>null;
            this.advertisement = _data["advertisement"] ? Advertisement.fromJS(_data["advertisement"]) : <any>null;
            if (Array.isArray(_data["messages"])) {
                this.messages = [] as any;
                for (let item of _data["messages"])
                    this.messages!.push(ConversationMessage.fromJS(item));
            }
        }
    }

    static fromJS(data: any): Conversation {
        data = typeof data === 'object' ? data : {};
        let result = new Conversation();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["conversationId"] = this.conversationId !== undefined ? this.conversationId : <any>null;
        data["senderEmail"] = this.senderEmail !== undefined ? this.senderEmail : <any>null;
        data["senderNick"] = this.senderNick !== undefined ? this.senderNick : <any>null;
        data["receiverNick"] = this.receiverNick !== undefined ? this.receiverNick : <any>null;
        data["receiverEmail"] = this.receiverEmail !== undefined ? this.receiverEmail : <any>null;
        data["conversationKey"] = this.conversationKey !== undefined ? this.conversationKey : <any>null;
        data["creationDate"] = this.creationDate ? this.creationDate.toISOString() : <any>null;
        data["ownerUserId"] = this.ownerUserId !== undefined ? this.ownerUserId : <any>null;
        data["ownerUser"] = this.ownerUser ? this.ownerUser.toJSON() : <any>null;
        data["receiverUserId"] = this.receiverUserId !== undefined ? this.receiverUserId : <any>null;
        data["receiverUser"] = this.receiverUser ? this.receiverUser.toJSON() : <any>null;
        data["advertisementId"] = this.advertisementId !== undefined ? this.advertisementId : <any>null;
        data["advertisement"] = this.advertisement ? this.advertisement.toJSON() : <any>null;
        if (Array.isArray(this.messages)) {
            data["messages"] = [];
            for (let item of this.messages)
                data["messages"].push(item.toJSON());
        }
        return data; 
    }

    clone(): Conversation {
        const json = this.toJSON();
        let result = new Conversation();
        result.init(json);
        return result;
    }
}

export interface IConversation {
    conversationId: number;
    senderEmail?: string | null;
    senderNick?: string | null;
    receiverNick?: string | null;
    receiverEmail?: string | null;
    conversationKey?: string | null;
    creationDate: moment.Moment;
    ownerUserId: number;
    ownerUser?: User | null;
    receiverUserId: number;
    receiverUser?: User | null;
    advertisementId: number;
    advertisement?: Advertisement | null;
    messages?: ConversationMessage[] | null;
}

export class User implements IUser {
    userId!: number;
    createdAt!: moment.Moment;
    updatedAt!: moment.Moment;
    nick?: string | null;
    lastName?: string | null;
    firstName?: string | null;
    email!: string;
    phone?: string | null;
    password!: string;
    passwordSalt!: string;
    isDemo!: boolean;
    isInternal!: boolean;
    isAdmin!: boolean;
    isEmailVerified!: boolean;
    isPremium!: boolean;
    isPhoneVerified!: boolean;
    isDisabled!: boolean;
    zipCode?: string | null;
    city?: string | null;
    state?: string | null;
    location?: Point | null;
    premiumAdTokens!: number;
    writeAdTokens!: number;
    subscribtionExpiration?: moment.Moment | null;

    constructor(data?: IUser) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.userId = _data["userId"] !== undefined ? _data["userId"] : <any>null;
            this.createdAt = _data["createdAt"] ? moment(_data["createdAt"].toString()) : <any>null;
            this.updatedAt = _data["updatedAt"] ? moment(_data["updatedAt"].toString()) : <any>null;
            this.nick = _data["nick"] !== undefined ? _data["nick"] : <any>null;
            this.lastName = _data["lastName"] !== undefined ? _data["lastName"] : <any>null;
            this.firstName = _data["firstName"] !== undefined ? _data["firstName"] : <any>null;
            this.email = _data["email"] !== undefined ? _data["email"] : <any>null;
            this.phone = _data["phone"] !== undefined ? _data["phone"] : <any>null;
            this.password = _data["password"] !== undefined ? _data["password"] : <any>null;
            this.passwordSalt = _data["passwordSalt"] !== undefined ? _data["passwordSalt"] : <any>null;
            this.isDemo = _data["isDemo"] !== undefined ? _data["isDemo"] : <any>null;
            this.isInternal = _data["isInternal"] !== undefined ? _data["isInternal"] : <any>null;
            this.isAdmin = _data["isAdmin"] !== undefined ? _data["isAdmin"] : <any>null;
            this.isEmailVerified = _data["isEmailVerified"] !== undefined ? _data["isEmailVerified"] : <any>null;
            this.isPremium = _data["isPremium"] !== undefined ? _data["isPremium"] : <any>null;
            this.isPhoneVerified = _data["isPhoneVerified"] !== undefined ? _data["isPhoneVerified"] : <any>null;
            this.isDisabled = _data["isDisabled"] !== undefined ? _data["isDisabled"] : <any>null;
            this.zipCode = _data["zipCode"] !== undefined ? _data["zipCode"] : <any>null;
            this.city = _data["city"] !== undefined ? _data["city"] : <any>null;
            this.state = _data["state"] !== undefined ? _data["state"] : <any>null;
            this.location = _data["location"] ? Point.fromJS(_data["location"]) : <any>null;
            this.premiumAdTokens = _data["premiumAdTokens"] !== undefined ? _data["premiumAdTokens"] : <any>null;
            this.writeAdTokens = _data["writeAdTokens"] !== undefined ? _data["writeAdTokens"] : <any>null;
            this.subscribtionExpiration = _data["subscribtionExpiration"] ? moment(_data["subscribtionExpiration"].toString()) : <any>null;
        }
    }

    static fromJS(data: any): User {
        data = typeof data === 'object' ? data : {};
        let result = new User();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userId"] = this.userId !== undefined ? this.userId : <any>null;
        data["createdAt"] = this.createdAt ? this.createdAt.toISOString() : <any>null;
        data["updatedAt"] = this.updatedAt ? this.updatedAt.toISOString() : <any>null;
        data["nick"] = this.nick !== undefined ? this.nick : <any>null;
        data["lastName"] = this.lastName !== undefined ? this.lastName : <any>null;
        data["firstName"] = this.firstName !== undefined ? this.firstName : <any>null;
        data["email"] = this.email !== undefined ? this.email : <any>null;
        data["phone"] = this.phone !== undefined ? this.phone : <any>null;
        data["password"] = this.password !== undefined ? this.password : <any>null;
        data["passwordSalt"] = this.passwordSalt !== undefined ? this.passwordSalt : <any>null;
        data["isDemo"] = this.isDemo !== undefined ? this.isDemo : <any>null;
        data["isInternal"] = this.isInternal !== undefined ? this.isInternal : <any>null;
        data["isAdmin"] = this.isAdmin !== undefined ? this.isAdmin : <any>null;
        data["isEmailVerified"] = this.isEmailVerified !== undefined ? this.isEmailVerified : <any>null;
        data["isPremium"] = this.isPremium !== undefined ? this.isPremium : <any>null;
        data["isPhoneVerified"] = this.isPhoneVerified !== undefined ? this.isPhoneVerified : <any>null;
        data["isDisabled"] = this.isDisabled !== undefined ? this.isDisabled : <any>null;
        data["zipCode"] = this.zipCode !== undefined ? this.zipCode : <any>null;
        data["city"] = this.city !== undefined ? this.city : <any>null;
        data["state"] = this.state !== undefined ? this.state : <any>null;
        data["location"] = this.location ? this.location.toJSON() : <any>null;
        data["premiumAdTokens"] = this.premiumAdTokens !== undefined ? this.premiumAdTokens : <any>null;
        data["writeAdTokens"] = this.writeAdTokens !== undefined ? this.writeAdTokens : <any>null;
        data["subscribtionExpiration"] = this.subscribtionExpiration ? this.subscribtionExpiration.toISOString() : <any>null;
        return data; 
    }

    clone(): User {
        const json = this.toJSON();
        let result = new User();
        result.init(json);
        return result;
    }
}

export interface IUser {
    userId: number;
    createdAt: moment.Moment;
    updatedAt: moment.Moment;
    nick?: string | null;
    lastName?: string | null;
    firstName?: string | null;
    email: string;
    phone?: string | null;
    password: string;
    passwordSalt: string;
    isDemo: boolean;
    isInternal: boolean;
    isAdmin: boolean;
    isEmailVerified: boolean;
    isPremium: boolean;
    isPhoneVerified: boolean;
    isDisabled: boolean;
    zipCode?: string | null;
    city?: string | null;
    state?: string | null;
    location?: Point | null;
    premiumAdTokens: number;
    writeAdTokens: number;
    subscribtionExpiration?: moment.Moment | null;
}

export class ConversationMessage implements IConversationMessage {
    conversationMessageId!: number;
    conversation?: Conversation | null;
    content?: string | null;
    creationDate!: moment.Moment;
    sender?: User | null;
    senderId!: number;
    title?: string | null;
    images?: ConversationImage[] | null;
    isRead!: boolean;

    constructor(data?: IConversationMessage) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.conversationMessageId = _data["conversationMessageId"] !== undefined ? _data["conversationMessageId"] : <any>null;
            this.conversation = _data["conversation"] ? Conversation.fromJS(_data["conversation"]) : <any>null;
            this.content = _data["content"] !== undefined ? _data["content"] : <any>null;
            this.creationDate = _data["creationDate"] ? moment(_data["creationDate"].toString()) : <any>null;
            this.sender = _data["sender"] ? User.fromJS(_data["sender"]) : <any>null;
            this.senderId = _data["senderId"] !== undefined ? _data["senderId"] : <any>null;
            this.title = _data["title"] !== undefined ? _data["title"] : <any>null;
            if (Array.isArray(_data["images"])) {
                this.images = [] as any;
                for (let item of _data["images"])
                    this.images!.push(ConversationImage.fromJS(item));
            }
            this.isRead = _data["isRead"] !== undefined ? _data["isRead"] : <any>null;
        }
    }

    static fromJS(data: any): ConversationMessage {
        data = typeof data === 'object' ? data : {};
        let result = new ConversationMessage();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["conversationMessageId"] = this.conversationMessageId !== undefined ? this.conversationMessageId : <any>null;
        data["conversation"] = this.conversation ? this.conversation.toJSON() : <any>null;
        data["content"] = this.content !== undefined ? this.content : <any>null;
        data["creationDate"] = this.creationDate ? this.creationDate.toISOString() : <any>null;
        data["sender"] = this.sender ? this.sender.toJSON() : <any>null;
        data["senderId"] = this.senderId !== undefined ? this.senderId : <any>null;
        data["title"] = this.title !== undefined ? this.title : <any>null;
        if (Array.isArray(this.images)) {
            data["images"] = [];
            for (let item of this.images)
                data["images"].push(item.toJSON());
        }
        data["isRead"] = this.isRead !== undefined ? this.isRead : <any>null;
        return data; 
    }

    clone(): ConversationMessage {
        const json = this.toJSON();
        let result = new ConversationMessage();
        result.init(json);
        return result;
    }
}

export interface IConversationMessage {
    conversationMessageId: number;
    conversation?: Conversation | null;
    content?: string | null;
    creationDate: moment.Moment;
    sender?: User | null;
    senderId: number;
    title?: string | null;
    images?: ConversationImage[] | null;
    isRead: boolean;
}

export class ConversationImage implements IConversationImage {
    conversationImageId!: number;
    conversationMessage?: ConversationMessage | null;
    name?: string | null;
    fileName?: string | null;

    constructor(data?: IConversationImage) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.conversationImageId = _data["conversationImageId"] !== undefined ? _data["conversationImageId"] : <any>null;
            this.conversationMessage = _data["conversationMessage"] ? ConversationMessage.fromJS(_data["conversationMessage"]) : <any>null;
            this.name = _data["name"] !== undefined ? _data["name"] : <any>null;
            this.fileName = _data["fileName"] !== undefined ? _data["fileName"] : <any>null;
        }
    }

    static fromJS(data: any): ConversationImage {
        data = typeof data === 'object' ? data : {};
        let result = new ConversationImage();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["conversationImageId"] = this.conversationImageId !== undefined ? this.conversationImageId : <any>null;
        data["conversationMessage"] = this.conversationMessage ? this.conversationMessage.toJSON() : <any>null;
        data["name"] = this.name !== undefined ? this.name : <any>null;
        data["fileName"] = this.fileName !== undefined ? this.fileName : <any>null;
        return data; 
    }

    clone(): ConversationImage {
        const json = this.toJSON();
        let result = new ConversationImage();
        result.init(json);
        return result;
    }
}

export interface IConversationImage {
    conversationImageId: number;
    conversationMessage?: ConversationMessage | null;
    name?: string | null;
    fileName?: string | null;
}

export class AdvertisementSetting implements IAdvertisementSetting {
    advertisementSettingId!: number;
    advertisementId!: number;
    showAs!: ShowAdType;
    advertisement?: Advertisement | null;

    constructor(data?: IAdvertisementSetting) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.advertisementSettingId = _data["advertisementSettingId"] !== undefined ? _data["advertisementSettingId"] : <any>null;
            this.advertisementId = _data["advertisementId"] !== undefined ? _data["advertisementId"] : <any>null;
            this.showAs = _data["showAs"] !== undefined ? _data["showAs"] : <any>null;
            this.advertisement = _data["advertisement"] ? Advertisement.fromJS(_data["advertisement"]) : <any>null;
        }
    }

    static fromJS(data: any): AdvertisementSetting {
        data = typeof data === 'object' ? data : {};
        let result = new AdvertisementSetting();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["advertisementSettingId"] = this.advertisementSettingId !== undefined ? this.advertisementSettingId : <any>null;
        data["advertisementId"] = this.advertisementId !== undefined ? this.advertisementId : <any>null;
        data["showAs"] = this.showAs !== undefined ? this.showAs : <any>null;
        data["advertisement"] = this.advertisement ? this.advertisement.toJSON() : <any>null;
        return data; 
    }

    clone(): AdvertisementSetting {
        const json = this.toJSON();
        let result = new AdvertisementSetting();
        result.init(json);
        return result;
    }
}

export interface IAdvertisementSetting {
    advertisementSettingId: number;
    advertisementId: number;
    showAs: ShowAdType;
    advertisement?: Advertisement | null;
}

export class VerifyPhoneResponseModel extends ResponseBaseModel implements IVerifyPhoneResponseModel {

    constructor(data?: IVerifyPhoneResponseModel) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
    }

    static fromJS(data: any): VerifyPhoneResponseModel {
        data = typeof data === 'object' ? data : {};
        let result = new VerifyPhoneResponseModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data; 
    }

    clone(): VerifyPhoneResponseModel {
        const json = this.toJSON();
        let result = new VerifyPhoneResponseModel();
        result.init(json);
        return result;
    }
}

export interface IVerifyPhoneResponseModel extends IResponseBaseModel {
}

export class VerifyPhoneModel implements IVerifyPhoneModel {
    userId!: number;

    constructor(data?: IVerifyPhoneModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.userId = _data["userId"] !== undefined ? _data["userId"] : <any>null;
        }
    }

    static fromJS(data: any): VerifyPhoneModel {
        data = typeof data === 'object' ? data : {};
        let result = new VerifyPhoneModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userId"] = this.userId !== undefined ? this.userId : <any>null;
        return data; 
    }

    clone(): VerifyPhoneModel {
        const json = this.toJSON();
        let result = new VerifyPhoneModel();
        result.init(json);
        return result;
    }
}

export interface IVerifyPhoneModel {
    userId: number;
}

export class ZipRequest implements IZipRequest {
    zip?: string | null;

    constructor(data?: IZipRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.zip = _data["zip"] !== undefined ? _data["zip"] : <any>null;
        }
    }

    static fromJS(data: any): ZipRequest {
        data = typeof data === 'object' ? data : {};
        let result = new ZipRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["zip"] = this.zip !== undefined ? this.zip : <any>null;
        return data; 
    }

    clone(): ZipRequest {
        const json = this.toJSON();
        let result = new ZipRequest();
        result.init(json);
        return result;
    }
}

export interface IZipRequest {
    zip?: string | null;
}

export class WeatherForecast implements IWeatherForecast {
    dateFormatted?: string | null;
    temperatureC!: number;
    summary?: string | null;
    temperatureF!: number;

    constructor(data?: IWeatherForecast) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.dateFormatted = _data["dateFormatted"] !== undefined ? _data["dateFormatted"] : <any>null;
            this.temperatureC = _data["temperatureC"] !== undefined ? _data["temperatureC"] : <any>null;
            this.summary = _data["summary"] !== undefined ? _data["summary"] : <any>null;
            this.temperatureF = _data["temperatureF"] !== undefined ? _data["temperatureF"] : <any>null;
        }
    }

    static fromJS(data: any): WeatherForecast {
        data = typeof data === 'object' ? data : {};
        let result = new WeatherForecast();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["dateFormatted"] = this.dateFormatted !== undefined ? this.dateFormatted : <any>null;
        data["temperatureC"] = this.temperatureC !== undefined ? this.temperatureC : <any>null;
        data["summary"] = this.summary !== undefined ? this.summary : <any>null;
        data["temperatureF"] = this.temperatureF !== undefined ? this.temperatureF : <any>null;
        return data; 
    }

    clone(): WeatherForecast {
        const json = this.toJSON();
        let result = new WeatherForecast();
        result.init(json);
        return result;
    }
}

export interface IWeatherForecast {
    dateFormatted?: string | null;
    temperatureC: number;
    summary?: string | null;
    temperatureF: number;
}

export abstract class ServiceResponseBase implements IServiceResponseBase {
    isError!: boolean;
    message?: string | null;

    constructor(data?: IServiceResponseBase) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.isError = _data["isError"] !== undefined ? _data["isError"] : <any>null;
            this.message = _data["message"] !== undefined ? _data["message"] : <any>null;
        }
    }

    static fromJS(data: any): ServiceResponseBase {
        data = typeof data === 'object' ? data : {};
        throw new Error("The abstract class 'ServiceResponseBase' cannot be instantiated.");
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["isError"] = this.isError !== undefined ? this.isError : <any>null;
        data["message"] = this.message !== undefined ? this.message : <any>null;
        return data; 
    }

    clone(): ServiceResponseBase {
        throw new Error("The abstract class 'ServiceResponseBase' cannot be instantiated.");
    }
}

export interface IServiceResponseBase {
    isError: boolean;
    message?: string | null;
}

export class CreateServiceResponse extends ServiceResponseBase implements ICreateServiceResponse {
    isCreated!: boolean;
    token?: string | null;

    constructor(data?: ICreateServiceResponse) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.isCreated = _data["isCreated"] !== undefined ? _data["isCreated"] : <any>null;
            this.token = _data["token"] !== undefined ? _data["token"] : <any>null;
        }
    }

    static fromJS(data: any): CreateServiceResponse {
        data = typeof data === 'object' ? data : {};
        let result = new CreateServiceResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["isCreated"] = this.isCreated !== undefined ? this.isCreated : <any>null;
        data["token"] = this.token !== undefined ? this.token : <any>null;
        super.toJSON(data);
        return data; 
    }

    clone(): CreateServiceResponse {
        const json = this.toJSON();
        let result = new CreateServiceResponse();
        result.init(json);
        return result;
    }
}

export interface ICreateServiceResponse extends IServiceResponseBase {
    isCreated: boolean;
    token?: string | null;
}

export class Subscribe implements ISubscribe {
    cardNumber?: string | null;
    expirationDate?: string | null;
    zip?: string | null;
    securityCode?: string | null;
    firstName?: string | null;
    lastName?: string | null;
    period!: Period;

    constructor(data?: ISubscribe) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.cardNumber = _data["cardNumber"] !== undefined ? _data["cardNumber"] : <any>null;
            this.expirationDate = _data["expirationDate"] !== undefined ? _data["expirationDate"] : <any>null;
            this.zip = _data["zip"] !== undefined ? _data["zip"] : <any>null;
            this.securityCode = _data["securityCode"] !== undefined ? _data["securityCode"] : <any>null;
            this.firstName = _data["firstName"] !== undefined ? _data["firstName"] : <any>null;
            this.lastName = _data["lastName"] !== undefined ? _data["lastName"] : <any>null;
            this.period = _data["period"] !== undefined ? _data["period"] : <any>null;
        }
    }

    static fromJS(data: any): Subscribe {
        data = typeof data === 'object' ? data : {};
        let result = new Subscribe();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["cardNumber"] = this.cardNumber !== undefined ? this.cardNumber : <any>null;
        data["expirationDate"] = this.expirationDate !== undefined ? this.expirationDate : <any>null;
        data["zip"] = this.zip !== undefined ? this.zip : <any>null;
        data["securityCode"] = this.securityCode !== undefined ? this.securityCode : <any>null;
        data["firstName"] = this.firstName !== undefined ? this.firstName : <any>null;
        data["lastName"] = this.lastName !== undefined ? this.lastName : <any>null;
        data["period"] = this.period !== undefined ? this.period : <any>null;
        return data; 
    }

    clone(): Subscribe {
        const json = this.toJSON();
        let result = new Subscribe();
        result.init(json);
        return result;
    }
}

export interface ISubscribe {
    cardNumber?: string | null;
    expirationDate?: string | null;
    zip?: string | null;
    securityCode?: string | null;
    firstName?: string | null;
    lastName?: string | null;
    period: Period;
}

export enum Period {
    Year = 1,
    Month = 2,
    SinglePremiumAd = 3,
}

export class SubscribtionData implements ISubscribtionData {
    subscribtionId?: string | null;
    firstName?: string | null;
    lastName?: string | null;
    creditCard?: string | null;
    zip?: string | null;
    type?: string | null;
    price?: string | null;
    nextBillingDate!: moment.Moment;
    status!: Status;

    constructor(data?: ISubscribtionData) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.subscribtionId = _data["subscribtionId"] !== undefined ? _data["subscribtionId"] : <any>null;
            this.firstName = _data["firstName"] !== undefined ? _data["firstName"] : <any>null;
            this.lastName = _data["lastName"] !== undefined ? _data["lastName"] : <any>null;
            this.creditCard = _data["creditCard"] !== undefined ? _data["creditCard"] : <any>null;
            this.zip = _data["zip"] !== undefined ? _data["zip"] : <any>null;
            this.type = _data["type"] !== undefined ? _data["type"] : <any>null;
            this.price = _data["price"] !== undefined ? _data["price"] : <any>null;
            this.nextBillingDate = _data["nextBillingDate"] ? moment(_data["nextBillingDate"].toString()) : <any>null;
            this.status = _data["status"] !== undefined ? _data["status"] : <any>null;
        }
    }

    static fromJS(data: any): SubscribtionData {
        data = typeof data === 'object' ? data : {};
        let result = new SubscribtionData();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["subscribtionId"] = this.subscribtionId !== undefined ? this.subscribtionId : <any>null;
        data["firstName"] = this.firstName !== undefined ? this.firstName : <any>null;
        data["lastName"] = this.lastName !== undefined ? this.lastName : <any>null;
        data["creditCard"] = this.creditCard !== undefined ? this.creditCard : <any>null;
        data["zip"] = this.zip !== undefined ? this.zip : <any>null;
        data["type"] = this.type !== undefined ? this.type : <any>null;
        data["price"] = this.price !== undefined ? this.price : <any>null;
        data["nextBillingDate"] = this.nextBillingDate ? this.nextBillingDate.toISOString() : <any>null;
        data["status"] = this.status !== undefined ? this.status : <any>null;
        return data; 
    }

    clone(): SubscribtionData {
        const json = this.toJSON();
        let result = new SubscribtionData();
        result.init(json);
        return result;
    }
}

export interface ISubscribtionData {
    subscribtionId?: string | null;
    firstName?: string | null;
    lastName?: string | null;
    creditCard?: string | null;
    zip?: string | null;
    type?: string | null;
    price?: string | null;
    nextBillingDate: moment.Moment;
    status: Status;
}

export enum Status {
    Active = 0,
    InActive = 1,
    Canceled = 2,
}

export class AddPremiumAdTokenResponse extends ServiceResponseBase implements IAddPremiumAdTokenResponse {
    isCreated!: boolean;

    constructor(data?: IAddPremiumAdTokenResponse) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.isCreated = _data["isCreated"] !== undefined ? _data["isCreated"] : <any>null;
        }
    }

    static fromJS(data: any): AddPremiumAdTokenResponse {
        data = typeof data === 'object' ? data : {};
        let result = new AddPremiumAdTokenResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["isCreated"] = this.isCreated !== undefined ? this.isCreated : <any>null;
        super.toJSON(data);
        return data; 
    }

    clone(): AddPremiumAdTokenResponse {
        const json = this.toJSON();
        let result = new AddPremiumAdTokenResponse();
        result.init(json);
        return result;
    }
}

export interface IAddPremiumAdTokenResponse extends IServiceResponseBase {
    isCreated: boolean;
}

export class AddPremiumAdToken implements IAddPremiumAdToken {
    cardNumber?: string | null;
    expirationDate?: string | null;
    zip?: string | null;
    securityCode?: string | null;
    firstName?: string | null;
    lastName?: string | null;

    constructor(data?: IAddPremiumAdToken) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.cardNumber = _data["cardNumber"] !== undefined ? _data["cardNumber"] : <any>null;
            this.expirationDate = _data["expirationDate"] !== undefined ? _data["expirationDate"] : <any>null;
            this.zip = _data["zip"] !== undefined ? _data["zip"] : <any>null;
            this.securityCode = _data["securityCode"] !== undefined ? _data["securityCode"] : <any>null;
            this.firstName = _data["firstName"] !== undefined ? _data["firstName"] : <any>null;
            this.lastName = _data["lastName"] !== undefined ? _data["lastName"] : <any>null;
        }
    }

    static fromJS(data: any): AddPremiumAdToken {
        data = typeof data === 'object' ? data : {};
        let result = new AddPremiumAdToken();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["cardNumber"] = this.cardNumber !== undefined ? this.cardNumber : <any>null;
        data["expirationDate"] = this.expirationDate !== undefined ? this.expirationDate : <any>null;
        data["zip"] = this.zip !== undefined ? this.zip : <any>null;
        data["securityCode"] = this.securityCode !== undefined ? this.securityCode : <any>null;
        data["firstName"] = this.firstName !== undefined ? this.firstName : <any>null;
        data["lastName"] = this.lastName !== undefined ? this.lastName : <any>null;
        return data; 
    }

    clone(): AddPremiumAdToken {
        const json = this.toJSON();
        let result = new AddPremiumAdToken();
        result.init(json);
        return result;
    }
}

export interface IAddPremiumAdToken {
    cardNumber?: string | null;
    expirationDate?: string | null;
    zip?: string | null;
    securityCode?: string | null;
    firstName?: string | null;
    lastName?: string | null;
}

export class AddWriteAdTokenResponse extends ServiceResponseBase implements IAddWriteAdTokenResponse {
    isCreated!: boolean;

    constructor(data?: IAddWriteAdTokenResponse) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.isCreated = _data["isCreated"] !== undefined ? _data["isCreated"] : <any>null;
        }
    }

    static fromJS(data: any): AddWriteAdTokenResponse {
        data = typeof data === 'object' ? data : {};
        let result = new AddWriteAdTokenResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["isCreated"] = this.isCreated !== undefined ? this.isCreated : <any>null;
        super.toJSON(data);
        return data; 
    }

    clone(): AddWriteAdTokenResponse {
        const json = this.toJSON();
        let result = new AddWriteAdTokenResponse();
        result.init(json);
        return result;
    }
}

export interface IAddWriteAdTokenResponse extends IServiceResponseBase {
    isCreated: boolean;
}

export class AddWriteAdToken implements IAddWriteAdToken {
    cardNumber?: string | null;
    expirationDate?: string | null;
    zip?: string | null;
    securityCode?: string | null;
    firstName?: string | null;
    lastName?: string | null;

    constructor(data?: IAddWriteAdToken) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.cardNumber = _data["cardNumber"] !== undefined ? _data["cardNumber"] : <any>null;
            this.expirationDate = _data["expirationDate"] !== undefined ? _data["expirationDate"] : <any>null;
            this.zip = _data["zip"] !== undefined ? _data["zip"] : <any>null;
            this.securityCode = _data["securityCode"] !== undefined ? _data["securityCode"] : <any>null;
            this.firstName = _data["firstName"] !== undefined ? _data["firstName"] : <any>null;
            this.lastName = _data["lastName"] !== undefined ? _data["lastName"] : <any>null;
        }
    }

    static fromJS(data: any): AddWriteAdToken {
        data = typeof data === 'object' ? data : {};
        let result = new AddWriteAdToken();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["cardNumber"] = this.cardNumber !== undefined ? this.cardNumber : <any>null;
        data["expirationDate"] = this.expirationDate !== undefined ? this.expirationDate : <any>null;
        data["zip"] = this.zip !== undefined ? this.zip : <any>null;
        data["securityCode"] = this.securityCode !== undefined ? this.securityCode : <any>null;
        data["firstName"] = this.firstName !== undefined ? this.firstName : <any>null;
        data["lastName"] = this.lastName !== undefined ? this.lastName : <any>null;
        return data; 
    }

    clone(): AddWriteAdToken {
        const json = this.toJSON();
        let result = new AddWriteAdToken();
        result.init(json);
        return result;
    }
}

export interface IAddWriteAdToken {
    cardNumber?: string | null;
    expirationDate?: string | null;
    zip?: string | null;
    securityCode?: string | null;
    firstName?: string | null;
    lastName?: string | null;
}

export class TupleOfIntegerAndDateTime implements ITupleOfIntegerAndDateTime {
    item1!: number;
    item2!: moment.Moment;

    constructor(data?: ITupleOfIntegerAndDateTime) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.item1 = _data["item1"] !== undefined ? _data["item1"] : <any>null;
            this.item2 = _data["item2"] ? moment(_data["item2"].toString()) : <any>null;
        }
    }

    static fromJS(data: any): TupleOfIntegerAndDateTime {
        data = typeof data === 'object' ? data : {};
        let result = new TupleOfIntegerAndDateTime();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["item1"] = this.item1 !== undefined ? this.item1 : <any>null;
        data["item2"] = this.item2 ? this.item2.toISOString() : <any>null;
        return data; 
    }

    clone(): TupleOfIntegerAndDateTime {
        const json = this.toJSON();
        let result = new TupleOfIntegerAndDateTime();
        result.init(json);
        return result;
    }
}

export interface ITupleOfIntegerAndDateTime {
    item1: number;
    item2: moment.Moment;
}

export class DemoAdvertisementGetTest implements IDemoAdvertisementGetTest {
    request?: AdveristmentGetModel | null;
    date!: moment.Moment;

    constructor(data?: IDemoAdvertisementGetTest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.request = _data["request"] ? AdveristmentGetModel.fromJS(_data["request"]) : <any>null;
            this.date = _data["date"] ? moment(_data["date"].toString()) : <any>null;
        }
    }

    static fromJS(data: any): DemoAdvertisementGetTest {
        data = typeof data === 'object' ? data : {};
        let result = new DemoAdvertisementGetTest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["request"] = this.request ? this.request.toJSON() : <any>null;
        data["date"] = this.date ? this.date.toISOString() : <any>null;
        return data; 
    }

    clone(): DemoAdvertisementGetTest {
        const json = this.toJSON();
        let result = new DemoAdvertisementGetTest();
        result.init(json);
        return result;
    }
}

export interface IDemoAdvertisementGetTest {
    request?: AdveristmentGetModel | null;
    date: moment.Moment;
}

export class RegistrationResponseModel extends ResponseBaseModel implements IRegistrationResponseModel {

    constructor(data?: IRegistrationResponseModel) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
    }

    static fromJS(data: any): RegistrationResponseModel {
        data = typeof data === 'object' ? data : {};
        let result = new RegistrationResponseModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data; 
    }

    clone(): RegistrationResponseModel {
        const json = this.toJSON();
        let result = new RegistrationResponseModel();
        result.init(json);
        return result;
    }
}

export interface IRegistrationResponseModel extends IResponseBaseModel {
}

export class RegistrationModel implements IRegistrationModel {
    email?: string | null;
    password?: string | null;
    passwordConfirmation?: string | null;
    zipCode?: string | null;
    city?: string | null;
    state?: string | null;
    phone?: string | null;

    constructor(data?: IRegistrationModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.email = _data["email"] !== undefined ? _data["email"] : <any>null;
            this.password = _data["password"] !== undefined ? _data["password"] : <any>null;
            this.passwordConfirmation = _data["passwordConfirmation"] !== undefined ? _data["passwordConfirmation"] : <any>null;
            this.zipCode = _data["zipCode"] !== undefined ? _data["zipCode"] : <any>null;
            this.city = _data["city"] !== undefined ? _data["city"] : <any>null;
            this.state = _data["state"] !== undefined ? _data["state"] : <any>null;
            this.phone = _data["phone"] !== undefined ? _data["phone"] : <any>null;
        }
    }

    static fromJS(data: any): RegistrationModel {
        data = typeof data === 'object' ? data : {};
        let result = new RegistrationModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["email"] = this.email !== undefined ? this.email : <any>null;
        data["password"] = this.password !== undefined ? this.password : <any>null;
        data["passwordConfirmation"] = this.passwordConfirmation !== undefined ? this.passwordConfirmation : <any>null;
        data["zipCode"] = this.zipCode !== undefined ? this.zipCode : <any>null;
        data["city"] = this.city !== undefined ? this.city : <any>null;
        data["state"] = this.state !== undefined ? this.state : <any>null;
        data["phone"] = this.phone !== undefined ? this.phone : <any>null;
        return data; 
    }

    clone(): RegistrationModel {
        const json = this.toJSON();
        let result = new RegistrationModel();
        result.init(json);
        return result;
    }
}

export interface IRegistrationModel {
    email?: string | null;
    password?: string | null;
    passwordConfirmation?: string | null;
    zipCode?: string | null;
    city?: string | null;
    state?: string | null;
    phone?: string | null;
}

export class ResetPasswordResponseModel extends ResponseBaseModel implements IResetPasswordResponseModel {

    constructor(data?: IResetPasswordResponseModel) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
    }

    static fromJS(data: any): ResetPasswordResponseModel {
        data = typeof data === 'object' ? data : {};
        let result = new ResetPasswordResponseModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data; 
    }

    clone(): ResetPasswordResponseModel {
        const json = this.toJSON();
        let result = new ResetPasswordResponseModel();
        result.init(json);
        return result;
    }
}

export interface IResetPasswordResponseModel extends IResponseBaseModel {
}

export class ResetPasswordModel implements IResetPasswordModel {
    email?: string | null;

    constructor(data?: IResetPasswordModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.email = _data["email"] !== undefined ? _data["email"] : <any>null;
        }
    }

    static fromJS(data: any): ResetPasswordModel {
        data = typeof data === 'object' ? data : {};
        let result = new ResetPasswordModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["email"] = this.email !== undefined ? this.email : <any>null;
        return data; 
    }

    clone(): ResetPasswordModel {
        const json = this.toJSON();
        let result = new ResetPasswordModel();
        result.init(json);
        return result;
    }
}

export interface IResetPasswordModel {
    email?: string | null;
}

export class GetEmailFromCodeResponseModel extends ResponseBaseModel implements IGetEmailFromCodeResponseModel {
    email?: string | null;

    constructor(data?: IGetEmailFromCodeResponseModel) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.email = _data["email"] !== undefined ? _data["email"] : <any>null;
        }
    }

    static fromJS(data: any): GetEmailFromCodeResponseModel {
        data = typeof data === 'object' ? data : {};
        let result = new GetEmailFromCodeResponseModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["email"] = this.email !== undefined ? this.email : <any>null;
        super.toJSON(data);
        return data; 
    }

    clone(): GetEmailFromCodeResponseModel {
        const json = this.toJSON();
        let result = new GetEmailFromCodeResponseModel();
        result.init(json);
        return result;
    }
}

export interface IGetEmailFromCodeResponseModel extends IResponseBaseModel {
    email?: string | null;
}

export class NewPasswordModel implements INewPasswordModel {
    email?: string | null;
    code?: string | null;
    password?: string | null;
    passwordConfirmation?: string | null;

    constructor(data?: INewPasswordModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.email = _data["email"] !== undefined ? _data["email"] : <any>null;
            this.code = _data["code"] !== undefined ? _data["code"] : <any>null;
            this.password = _data["password"] !== undefined ? _data["password"] : <any>null;
            this.passwordConfirmation = _data["passwordConfirmation"] !== undefined ? _data["passwordConfirmation"] : <any>null;
        }
    }

    static fromJS(data: any): NewPasswordModel {
        data = typeof data === 'object' ? data : {};
        let result = new NewPasswordModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["email"] = this.email !== undefined ? this.email : <any>null;
        data["code"] = this.code !== undefined ? this.code : <any>null;
        data["password"] = this.password !== undefined ? this.password : <any>null;
        data["passwordConfirmation"] = this.passwordConfirmation !== undefined ? this.passwordConfirmation : <any>null;
        return data; 
    }

    clone(): NewPasswordModel {
        const json = this.toJSON();
        let result = new NewPasswordModel();
        result.init(json);
        return result;
    }
}

export interface INewPasswordModel {
    email?: string | null;
    code?: string | null;
    password?: string | null;
    passwordConfirmation?: string | null;
}

export class ValidateResponseModel extends ResponseBaseModel implements IValidateResponseModel {
    userId!: number;
    userPhone?: string | null;

    constructor(data?: IValidateResponseModel) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.userId = _data["userId"] !== undefined ? _data["userId"] : <any>null;
            this.userPhone = _data["userPhone"] !== undefined ? _data["userPhone"] : <any>null;
        }
    }

    static fromJS(data: any): ValidateResponseModel {
        data = typeof data === 'object' ? data : {};
        let result = new ValidateResponseModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userId"] = this.userId !== undefined ? this.userId : <any>null;
        data["userPhone"] = this.userPhone !== undefined ? this.userPhone : <any>null;
        super.toJSON(data);
        return data; 
    }

    clone(): ValidateResponseModel {
        const json = this.toJSON();
        let result = new ValidateResponseModel();
        result.init(json);
        return result;
    }
}

export interface IValidateResponseModel extends IResponseBaseModel {
    userId: number;
    userPhone?: string | null;
}

export class ValidatePhoneModel implements IValidatePhoneModel {
    code?: string | null;
    userId!: number;

    constructor(data?: IValidatePhoneModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.code = _data["code"] !== undefined ? _data["code"] : <any>null;
            this.userId = _data["userId"] !== undefined ? _data["userId"] : <any>null;
        }
    }

    static fromJS(data: any): ValidatePhoneModel {
        data = typeof data === 'object' ? data : {};
        let result = new ValidatePhoneModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["code"] = this.code !== undefined ? this.code : <any>null;
        data["userId"] = this.userId !== undefined ? this.userId : <any>null;
        return data; 
    }

    clone(): ValidatePhoneModel {
        const json = this.toJSON();
        let result = new ValidatePhoneModel();
        result.init(json);
        return result;
    }
}

export interface IValidatePhoneModel {
    code?: string | null;
    userId: number;
}

export class ValidateModel implements IValidateModel {
    value?: string | null;
    type?: string | null;
    code?: string | null;

    constructor(data?: IValidateModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.value = _data["value"] !== undefined ? _data["value"] : <any>null;
            this.type = _data["type"] !== undefined ? _data["type"] : <any>null;
            this.code = _data["code"] !== undefined ? _data["code"] : <any>null;
        }
    }

    static fromJS(data: any): ValidateModel {
        data = typeof data === 'object' ? data : {};
        let result = new ValidateModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["value"] = this.value !== undefined ? this.value : <any>null;
        data["type"] = this.type !== undefined ? this.type : <any>null;
        data["code"] = this.code !== undefined ? this.code : <any>null;
        return data; 
    }

    clone(): ValidateModel {
        const json = this.toJSON();
        let result = new ValidateModel();
        result.init(json);
        return result;
    }
}

export interface IValidateModel {
    value?: string | null;
    type?: string | null;
    code?: string | null;
}

export interface FileResponse {
    data: Blob;
    status: number;
    fileName?: string;
    headers?: { [name: string]: any };
}

export class SwaggerException extends Error {
    message: string;
    status: number;
    response: string;
    headers: { [key: string]: any; };
    result: any;

    constructor(message: string, status: number, response: string, headers: { [key: string]: any; }, result: any) {
        super();

        this.message = message;
        this.status = status;
        this.response = response;
        this.headers = headers;
        this.result = result;
    }

    protected isSwaggerException = true;

    static isSwaggerException(obj: any): obj is SwaggerException {
        return obj.isSwaggerException === true;
    }
}

function throwException(message: string, status: number, response: string, headers: { [key: string]: any; }, result?: any): Observable<any> {
    if (result !== null && result !== undefined)
        return _observableThrow(result);
    else
        return _observableThrow(new SwaggerException(message, status, response, headers, null));
}

function blobToText(blob: any): Observable<string> {
    return new Observable<string>((observer: any) => {
        if (!blob) {
            observer.next("");
            observer.complete();
        } else {
            let reader = new FileReader();
            reader.onload = event => {
                observer.next((<any>event.target).result);
                observer.complete();
            };
            reader.readAsText(blob);
        }
    });
}